import { jsxs as m, jsx as t, Fragment as re } from "react/jsx-runtime";
import * as e from "react";
import { useState as F, useRef as S, useEffect as U, createContext as Ye, forwardRef as x, useId as W, useCallback as T, useLayoutEffect as At, useMemo as Nt, useContext as qe } from "react";
import { createPortal as ct } from "react-dom";
const sa = "AppShell-module__shell___sfjp5", ia = "AppShell-module__header___q88zN", da = "AppShell-module__body___hv--l", _a = "AppShell-module__left___sg1tG", ma = "AppShell-module__right___1R1W7", ua = "AppShell-module__sidebar___behPB", pa = "AppShell-module__main___NwE-A", Ze = {
  shell: sa,
  header: ia,
  body: da,
  left: _a,
  right: ma,
  sidebar: ua,
  main: pa
};
function m2({
  header: n,
  sidebar: a,
  sidebarPosition: l = "left",
  children: o,
  className: r
}) {
  return /* @__PURE__ */ m("div", { className: `${Ze.shell} ${r ?? ""}`, children: [
    n && /* @__PURE__ */ t("header", { className: Ze.header, children: n }),
    /* @__PURE__ */ m("div", { className: `${Ze.body} ${Ze[l]}`, children: [
      a && /* @__PURE__ */ t("aside", { className: Ze.sidebar, children: a }),
      /* @__PURE__ */ t("main", { className: Ze.main, children: o })
    ] })
  ] });
}
const ha = "ShellPanel-module__shellPanel___t0isC", ga = "ShellPanel-module__content___vnBme", ba = "ShellPanel-module__contentCollapsed___xNTnF", fa = "ShellPanel-module__resizeHandle___psYKv", Qe = {
  shellPanel: ha,
  content: ga,
  contentCollapsed: ba,
  resizeHandle: fa
};
function Me(n) {
  return Math.floor(window.innerWidth * n / 100);
}
function u2({
  actionBar: n,
  children: a,
  collapsed: l = !1,
  defaultWidth: o = 320,
  defaultWidthVw: r,
  resizable: c = !1,
  onResize: s,
  minWidth: d = 200,
  maxWidth: i = 800,
  minWidthVw: h,
  maxWidthVw: _,
  className: u
}) {
  const [g, N] = F(
    () => _ ? Me(_) : i
  ), [E, M] = F(
    () => h ? Me(h) : d
  ), [y, w] = F(o), H = S(!1), b = S(!1), v = S(0), p = S(0);
  U(() => {
    const A = r ? Me(r) : o, Z = Math.min(g, Math.max(E, A));
    Z !== y && (H.current = !1, w(Z));
  }, [o, r, g, E]), U(() => {
    if (!_ && !h && !r)
      return;
    const A = () => {
      const Z = _ ? Me(_) : i, f = h ? Me(h) : d;
      N(Z), M(f), w((C) => {
        const k = !H.current && r ? Me(r) : C;
        return Math.min(Z, Math.max(f, k));
      });
    };
    return window.addEventListener("resize", A), () => window.removeEventListener("resize", A);
  }, [_, h, r, i, d]), U(() => {
    if (!c)
      return;
    function A(f) {
      if (!b.current)
        return;
      const C = f.clientX - v.current, k = Math.min(
        g,
        Math.max(E, p.current + C)
      );
      w(k), H.current = !0, s?.(k);
    }
    function Z() {
      b.current = !1, document.body.style.cursor = "", document.body.style.userSelect = "";
    }
    return window.addEventListener("mousemove", A), window.addEventListener("mouseup", Z), () => {
      window.removeEventListener("mousemove", A), window.removeEventListener("mouseup", Z);
    };
  }, [c, E, g, s]);
  function $(A) {
    b.current = !0, v.current = A.clientX, p.current = y, document.body.style.cursor = "col-resize", document.body.style.userSelect = "none";
  }
  return /* @__PURE__ */ m("div", { className: `${Qe.shellPanel} ${u ?? ""}`, children: [
    n,
    /* @__PURE__ */ t(
      "div",
      {
        className: `${Qe.content} ${l ? Qe.contentCollapsed : ""}`,
        style: { width: l ? 0 : y },
        "aria-hidden": l ? "true" : void 0,
        children: a
      }
    ),
    c && !l && /* @__PURE__ */ t(
      "div",
      {
        className: Qe.resizeHandle,
        onMouseDown: $,
        "aria-hidden": "true"
      }
    )
  ] });
}
const va = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H69l51.52,51.51a12,12,0,0,1-17,17l-72-72a12,12,0,0,1,0-17l72-72a12,12,0,0,1,17,17L69,116H216A12,12,0,0,1,228,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M112,56V200L40,128Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M216,120H120V56a8,8,0,0,0-13.66-5.66l-72,72a8,8,0,0,0,0,11.32l72,72A8,8,0,0,0,120,200V136h96a8,8,0,0,0,0-16ZM104,180.69,51.31,128,104,75.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H120v64a8,8,0,0,1-13.66,5.66l-72-72a8,8,0,0,1,0-11.32l72-72A8,8,0,0,1,120,56v64h96A8,8,0,0,1,224,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H54.49l61.75,61.76a6,6,0,1,1-8.48,8.48l-72-72a6,6,0,0,1,0-8.48l72-72a6,6,0,0,1,8.48,8.48L54.49,122H216A6,6,0,0,1,222,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H49.66l65.17,65.17a4,4,0,0,1-5.66,5.66l-72-72a4,4,0,0,1,0-5.66l72-72a4,4,0,0,1,5.66,5.66L49.66,124H216A4,4,0,0,1,220,128Z" }))
  ]
]), $a = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,96l-80,80L48,96Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M215.39,92.94A8,8,0,0,0,208,88H48a8,8,0,0,0-5.66,13.66l80,80a8,8,0,0,0,11.32,0l80-80A8,8,0,0,0,215.39,92.94ZM128,164.69,67.31,104H188.69Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,48,88H208a8,8,0,0,1,5.66,13.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M212.24,100.24l-80,80a6,6,0,0,1-8.48,0l-80-80a6,6,0,0,1,8.48-8.48L128,167.51l75.76-75.75a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M210.83,98.83l-80,80a4,4,0,0,1-5.66,0l-80-80a4,4,0,0,1,5.66-5.66L128,170.34l77.17-77.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), Aa = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M160,48V208L80,128Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M163.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,168,208V48A8,8,0,0,0,163.06,40.61ZM152,188.69,91.31,128,152,67.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,168,48Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M164.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L88.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M162.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L85.66,128Z" }))
  ]
]), Na = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M176,128,96,208V48Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }))
  ]
]), Ea = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216.49,168.49a12,12,0,0,1-17,0L128,97,56.49,168.49a12,12,0,0,1-17-17l80-80a12,12,0,0,1,17,0l80,80A12,12,0,0,1,216.49,168.49Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,160H48l80-80Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M213.66,154.34l-80-80a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,168H208a8,8,0,0,0,5.66-13.66ZM67.31,152,128,91.31,188.69,152Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M215.39,163.06A8,8,0,0,1,208,168H48a8,8,0,0,1-5.66-13.66l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,215.39,163.06Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M212.24,164.24a6,6,0,0,1-8.48,0L128,88.49,52.24,164.24a6,6,0,0,1-8.48-8.48l80-80a6,6,0,0,1,8.48,0l80,80A6,6,0,0,1,212.24,164.24Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M210.83,162.83a4,4,0,0,1-5.66,0L128,85.66,50.83,162.83a4,4,0,0,1-5.66-5.66l80-80a4,4,0,0,1,5.66,0l80,80A4,4,0,0,1,210.83,162.83Z" }))
  ]
]), wa = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M184.49,167.51a12,12,0,0,1,0,17l-48,48a12,12,0,0,1-17,0l-48-48a12,12,0,0,1,17-17L128,207l39.51-39.52A12,12,0,0,1,184.49,167.51Zm-96-79L128,49l39.51,39.52a12,12,0,0,0,17-17l-48-48a12,12,0,0,0-17,0l-48,48a12,12,0,0,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M80,176h96l-48,48ZM128,32,80,80h96Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Zm-48,44.69L99.31,184h57.38ZM80,88h96a8,8,0,0,0,5.66-13.66l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,80,88Zm48-44.69L156.69,72H99.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M72.61,83.06a8,8,0,0,1,1.73-8.72l48-48a8,8,0,0,1,11.32,0l48,48A8,8,0,0,1,176,88H80A8,8,0,0,1,72.61,83.06ZM176,168H80a8,8,0,0,0-5.66,13.66l48,48a8,8,0,0,0,11.32,0l48-48A8,8,0,0,0,176,168Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M180.24,171.76a6,6,0,0,1,0,8.48l-48,48a6,6,0,0,1-8.48,0l-48-48a6,6,0,0,1,8.48-8.48L128,215.51l43.76-43.75A6,6,0,0,1,180.24,171.76Zm-96-87.52L128,40.49l43.76,43.75a6,6,0,0,0,8.48-8.48l-48-48a6,6,0,0,0-8.48,0l-48,48a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M181.66,170.34a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L128,212.69l42.34-42.35A8,8,0,0,1,181.66,170.34Zm-96-84.68L128,43.31l42.34,42.35a8,8,0,0,0,11.32-11.32l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,85.66,85.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.83,173.17a4,4,0,0,1,0,5.66l-48,48a4,4,0,0,1-5.66,0l-48-48a4,4,0,0,1,5.66-5.66L128,218.34l45.17-45.17A4,4,0,0,1,178.83,173.17Zm-96-90.34L128,37.66l45.17,45.17a4,4,0,1,0,5.66-5.66l-48-48a4,4,0,0,0-5.66,0l-48,48a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), Za = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M232,56V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM205.66,85.66l-96,96a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L104,164.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228.24,76.24l-128,128a6,6,0,0,1-8.48,0l-56-56a6,6,0,0,1,8.48-8.48L96,191.51,219.76,67.76a6,6,0,0,1,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M226.83,74.83l-128,128a4,4,0,0,1-5.66,0l-56-56a4,4,0,0,1,5.66-5.66L96,194.34,221.17,69.17a4,4,0,1,1,5.66,5.66Z" }))
  ]
]), Ma = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M176.49,95.51a12,12,0,0,1,0,17l-56,56a12,12,0,0,1-17,0l-24-24a12,12,0,1,1,17-17L112,143l47.51-47.52A12,12,0,0,1,176.49,95.51ZM236,128A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,85.66-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M172.24,99.76a6,6,0,0,1,0,8.48l-56,56a6,6,0,0,1-8.48,0l-24-24a6,6,0,0,1,8.48-8.48L112,151.51l51.76-51.75A6,6,0,0,1,172.24,99.76ZM230,128A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M170.83,101.17a4,4,0,0,1,0,5.66l-56,56a4,4,0,0,1-5.66,0l-24-24a4,4,0,0,1,5.66-5.66L112,154.34l53.17-53.17A4,4,0,0,1,170.83,101.17ZM228,128A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), ya = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M196.49,151.51a12,12,0,0,1-17,17L168,157v51a12,12,0,0,1-24,0V157l-11.51,11.52a12,12,0,1,1-17-17l32-32a12,12,0,0,1,17,0ZM160,36A92.08,92.08,0,0,0,79,84.37,68,68,0,1,0,72,220h28a12,12,0,0,0,0-24H72a44,44,0,0,1-1.81-87.95A91.7,91.7,0,0,0,68,128a12,12,0,0,0,24,0,68,68,0,1,1,132.6,21.29,12,12,0,1,0,22.8,7.51A92.06,92.06,0,0,0,160,36Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M240,128a80,80,0,0,1-80,80H72A56,56,0,1,1,85.92,97.74l0,.1A80,80,0,0,1,240,128Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M178.34,165.66,160,147.31V208a8,8,0,0,1-16,0V147.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32ZM160,40A88.08,88.08,0,0,0,81.29,88.68,64,64,0,1,0,72,216h40a8,8,0,0,0,0-16H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.12A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,100.8,66,8,8,0,0,0,3.2,15.34,7.9,7.9,0,0,0,3.2-.68A88,88,0,0,0,160,40Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M247.93,124.52C246.11,77.54,207.07,40,160.06,40A88.1,88.1,0,0,0,81.29,88.67h0A87.48,87.48,0,0,0,72,127.73,8.18,8.18,0,0,1,64.57,136,8,8,0,0,1,56,128a103.66,103.66,0,0,1,5.34-32.92,4,4,0,0,0-4.75-5.18A64.09,64.09,0,0,0,8,152c0,35.19,29.75,64,65,64H160A88.09,88.09,0,0,0,247.93,124.52Zm-50.27,9.14a8,8,0,0,1-11.32,0L168,115.31V176a8,8,0,0,1-16,0V115.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32A8,8,0,0,1,197.66,133.66Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M188.24,164.24a6,6,0,0,1-8.48,0L158,142.49V208a6,6,0,0,1-12,0V142.49l-21.76,21.75a6,6,0,0,1-8.48-8.48l32-32a6,6,0,0,1,8.48,0l32,32A6,6,0,0,1,188.24,164.24ZM160,42A86.1,86.1,0,0,0,82.43,90.88,62,62,0,1,0,72,214h40a6,6,0,0,0,0-12H72a50,50,0,0,1,0-100,50.68,50.68,0,0,1,5.91.36A85.54,85.54,0,0,0,74,128a6,6,0,0,0,12,0,74,74,0,1,1,103.6,67.85,6,6,0,0,0,4.8,11A86,86,0,0,0,160,42Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.34,165.66,160,147.31V208a8,8,0,0,1-16,0V147.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32ZM160,40A88.08,88.08,0,0,0,81.29,88.68,64,64,0,1,0,72,216h40a8,8,0,0,0,0-16H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.12A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,100.8,66,8,8,0,0,0,3.2,15.34,7.9,7.9,0,0,0,3.2-.68A88,88,0,0,0,160,40Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M186.83,162.83a4,4,0,0,1-5.66,0L156,137.66V208a4,4,0,0,1-8,0V137.66l-25.17,25.17a4,4,0,0,1-5.66-5.66l32-32a4,4,0,0,1,5.66,0l32,32A4,4,0,0,1,186.83,162.83ZM160,44A84.09,84.09,0,0,0,83.61,93.13,60,60,0,1,0,72,212h40a4,4,0,0,0,0-8H72a52,52,0,1,1,8.57-103.27A83.45,83.45,0,0,0,76,128a4,4,0,0,0,8,0,76,76,0,1,1,106.4,69.68,4,4,0,0,0,1.6,7.66,3.92,3.92,0,0,0,1.6-.33A84,84,0,0,0,160,44Z" }))
  ]
]), La = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M108,60A16,16,0,1,1,92,44,16,16,0,0,1,108,60Zm56,16a16,16,0,1,0-16-16A16,16,0,0,0,164,76ZM92,112a16,16,0,1,0,16,16A16,16,0,0,0,92,112Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,112ZM92,180a16,16,0,1,0,16,16A16,16,0,0,0,92,180Zm72,0a16,16,0,1,0,16,16A16,16,0,0,0,164,180Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M208,32V224a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V32A16,16,0,0,1,64,16H192A16,16,0,0,1,208,32Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M192,16H64A16,16,0,0,0,48,32V224a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V32A16,16,0,0,0,192,16ZM100,200a12,12,0,1,1,12-12A12,12,0,0,1,100,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,100,80Zm56,120a12,12,0,1,1,12-12A12,12,0,0,1,156,200Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,140Zm0-60a12,12,0,1,1,12-12A12,12,0,0,1,156,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M102,60A10,10,0,1,1,92,50,10,10,0,0,1,102,60Zm62,10a10,10,0,1,0-10-10A10,10,0,0,0,164,70ZM92,118a10,10,0,1,0,10,10A10,10,0,0,0,92,118Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,118ZM92,186a10,10,0,1,0,10,10A10,10,0,0,0,92,186Zm72,0a10,10,0,1,0,10,10A10,10,0,0,0,164,186Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M100,60a8,8,0,1,1-8-8A8,8,0,0,1,100,60Zm64,8a8,8,0,1,0-8-8A8,8,0,0,0,164,68ZM92,120a8,8,0,1,0,8,8A8,8,0,0,0,92,120Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,120ZM92,188a8,8,0,1,0,8,8A8,8,0,0,0,92,188Zm72,0a8,8,0,1,0,8,8A8,8,0,0,0,164,188Z" }))
  ]
]), Ha = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M114,145.34a12,12,0,0,0-20,0L79,167.82,72.3,157.73a12,12,0,0,0-20.07.17L13.91,217.51A12,12,0,0,0,24,236H152a12,12,0,0,0,10-18.66ZM46,212,62.5,186.3l6.55,9.81a12,12,0,0,0,20,0l15-22.48L129.58,212ZM216.49,79.51l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40v84a12,12,0,0,0,24,0V44h76V92a12,12,0,0,0,12,12h48V212a12,12,0,0,0,0,24h4a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.51ZM160,57l23,23H160Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M104,152l48,72H24l36-56,16.36,25.45ZM152,32V88h56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M110.66,147.56a8,8,0,0,0-13.32,0L76.49,178.85l-9.76-15.18a8,8,0,0,0-13.46,0l-36,56A8,8,0,0,0,24,232H152a8,8,0,0,0,6.66-12.44ZM38.65,216,60,182.79l9.63,15a8,8,0,0,0,13.39.11l21-31.47L137.05,216Zm175-133.66-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M158.66,219.56A8,8,0,0,1,152,232H24a8,8,0,0,1-6.73-12.33l36-56a8,8,0,0,1,13.46,0l9.76,15.18,20.85-31.29a8,8,0,0,1,13.32,0ZM216,88V216a16,16,0,0,1-16,16h-8a8,8,0,0,1,0-16h8V96H152a8,8,0,0,1-8-8V40H56v88a8,8,0,0,1-16,0V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88Zm-56-8h28.69L160,51.31Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M109,148.67a6,6,0,0,0-10,0L76.46,182.5,65.05,164.76a6,6,0,0,0-10.1,0l-36,56A6,6,0,0,0,24,230H152a6,6,0,0,0,5-9.33ZM35,218l25-38.9,11.32,17.6a6,6,0,0,0,10,.08l22.64-34L140.79,218ZM212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40v88a6,6,0,0,0,12,0V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216a2,2,0,0,1-2,2h-8a6,6,0,0,0,0,12h8a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M110.66,147.56a8,8,0,0,0-13.32,0L76.49,178.85l-9.76-15.18a8,8,0,0,0-13.46,0l-36,56A8,8,0,0,0,24,232H152a8,8,0,0,0,6.66-12.44ZM38.65,216,60,182.79l9.63,15a8,8,0,0,0,13.39.11l21-31.47L137.05,216Zm175-133.66-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M107.33,149.78a4,4,0,0,0-6.66,0L76.42,186.15,63.36,165.84a4,4,0,0,0-6.72,0l-36,56A4,4,0,0,0,24,228H152a4,4,0,0,0,3.33-6.22ZM31.33,220,60,175.4l13,20.22a4,4,0,0,0,3.33,1.83,3.93,3.93,0,0,0,3.36-1.78L104,159.21,144.53,220ZM210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40v88a4,4,0,0,0,8,0V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216a4,4,0,0,1-4,4h-8a4,4,0,0,0,0,8h8a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156Z" }))
  ]
]), Ca = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M108,84a16,16,0,1,1,16,16A16,16,0,0,1,108,84Zm128,44A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128Zm-72,36.68V132a20,20,0,0,0-20-20,12,12,0,0,0-4,23.32V168a20,20,0,0,0,20,20,12,12,0,0,0,4-23.32Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M144,176a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176Zm88-48A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128ZM124,96a12,12,0,1,0-12-12A12,12,0,0,0,124,96Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm-4,48a12,12,0,1,1-12,12A12,12,0,0,1,124,72Zm12,112a16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M142,176a6,6,0,0,1-6,6,14,14,0,0,1-14-14V128a2,2,0,0,0-2-2,6,6,0,0,1,0-12,14,14,0,0,1,14,14v40a2,2,0,0,0,2,2A6,6,0,0,1,142,176ZM124,94a10,10,0,1,0-10-10A10,10,0,0,0,124,94Zm106,34A102,102,0,1,1,128,26,102.12,102.12,0,0,1,230,128Zm-12,0a90,90,0,1,0-90,90A90.1,90.1,0,0,0,218,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M140,176a4,4,0,0,1-4,4,12,12,0,0,1-12-12V128a4,4,0,0,0-4-4,4,4,0,0,1,0-8,12,12,0,0,1,12,12v40a4,4,0,0,0,4,4A4,4,0,0,1,140,176ZM124,92a8,8,0,1,0-8-8A8,8,0,0,0,124,92Zm104,36A100,100,0,1,1,128,28,100.11,100.11,0,0,1,228,128Zm-8,0a92,92,0,1,0-92,92A92.1,92.1,0,0,0,220,128Z" }))
  ]
]), ka = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M87.5,151.52l64-64a12,12,0,0,1,17,17l-64,64a12,12,0,0,1-17-17Zm131-114a60.08,60.08,0,0,0-84.87,0L103.51,67.61a12,12,0,0,0,17,17l30.07-30.06a36,36,0,0,1,50.93,50.92L171.4,135.52a12,12,0,1,0,17,17l30.08-30.06A60.09,60.09,0,0,0,218.45,37.55ZM135.52,171.4l-30.07,30.08a36,36,0,0,1-50.92-50.93l30.06-30.07a12,12,0,0,0-17-17L37.55,133.58a60,60,0,0,0,84.88,84.87l30.06-30.07a12,12,0,0,0-17-17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M209.94,113.94l-96,96a48,48,0,0,1-67.88-67.88l96-96a48,48,0,0,1,67.88,67.88Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M165.66,90.34a8,8,0,0,1,0,11.32l-64,64a8,8,0,0,1-11.32-11.32l64-64A8,8,0,0,1,165.66,90.34ZM215.6,40.4a56,56,0,0,0-79.2,0L106.34,70.45a8,8,0,0,0,11.32,11.32l30.06-30a40,40,0,0,1,56.57,56.56l-30.07,30.06a8,8,0,0,0,11.31,11.32L215.6,119.6a56,56,0,0,0,0-79.2ZM138.34,174.22l-30.06,30.06a40,40,0,1,1-56.56-56.57l30.05-30.05a8,8,0,0,0-11.32-11.32L40.4,136.4a56,56,0,0,0,79.2,79.2l30.06-30.07a8,8,0,0,0-11.32-11.31Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM144.56,173.66l-21.45,21.45a44,44,0,0,1-62.22-62.22l21.45-21.46a8,8,0,0,1,11.32,11.31L72.2,144.2a28,28,0,0,0,39.6,39.6l21.45-21.46a8,8,0,0,1,11.31,11.32Zm-34.9-16a8,8,0,0,1-11.32-11.32l48-48a8,8,0,0,1,11.32,11.32Zm85.45-34.55-21.45,21.45a8,8,0,0,1-11.32-11.31L183.8,111.8a28,28,0,0,0-39.6-39.6L122.74,93.66a8,8,0,0,1-11.31-11.32l21.46-21.45a44,44,0,0,1,62.22,62.22Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M164.25,91.75a6,6,0,0,1,0,8.49l-64,64a6,6,0,0,1-8.49-8.48l64-64A6,6,0,0,1,164.25,91.75ZM214.2,41.8a54.07,54.07,0,0,0-76.38,0L107.75,71.85a6,6,0,0,0,8.49,8.49l30.07-30.06a42,42,0,0,1,59.41,59.41l-30.08,30.07a6,6,0,1,0,8.49,8.49l30.07-30.07A54,54,0,0,0,214.2,41.8ZM139.76,175.64l-30.07,30.08a42,42,0,0,1-59.41-59.41l30.06-30.07a6,6,0,0,0-8.49-8.49l-30,30.07a54,54,0,0,0,76.38,76.39l30.07-30.08a6,6,0,0,0-8.49-8.49Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M165.66,90.34a8,8,0,0,1,0,11.32l-64,64a8,8,0,0,1-11.32-11.32l64-64A8,8,0,0,1,165.66,90.34ZM215.6,40.4a56,56,0,0,0-79.2,0L106.34,70.45a8,8,0,0,0,11.32,11.32l30.06-30a40,40,0,0,1,56.57,56.56l-30.07,30.06a8,8,0,0,0,11.31,11.32L215.6,119.6a56,56,0,0,0,0-79.2ZM138.34,174.22l-30.06,30.06a40,40,0,1,1-56.56-56.57l30.05-30.05a8,8,0,0,0-11.32-11.32L40.4,136.4a56,56,0,0,0,79.2,79.2l30.06-30.07a8,8,0,0,0-11.32-11.31Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M162.84,93.16a4,4,0,0,1,0,5.66l-64,64a4,4,0,0,1-5.66-5.66l64-64A4,4,0,0,1,162.84,93.16Zm49.95-49.95a52.07,52.07,0,0,0-73.56,0L109.17,73.27a4,4,0,0,0,5.65,5.66l30.07-30.06a44,44,0,0,1,62.24,62.24l-30.07,30.06a4,4,0,0,0,5.66,5.66l30.07-30.06A52.07,52.07,0,0,0,212.79,43.21ZM141.17,177.06l-30.06,30.07a44,44,0,0,1-62.24-62.24l30.06-30.06a4,4,0,0,0-5.66-5.66L43.21,139.23a52,52,0,0,0,73.56,73.56l30.06-30.07a4,4,0,1,0-5.66-5.66Z" }))
  ]
]), Sa = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M76,64A12,12,0,0,1,88,52H216a12,12,0,0,1,0,24H88A12,12,0,0,1,76,64Zm140,52H88a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Zm0,64H88a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24ZM44,112a16,16,0,1,0,16,16A16,16,0,0,0,44,112Zm0-64A16,16,0,1,0,60,64,16,16,0,0,0,44,48Zm0,128a16,16,0,1,0,16,16A16,16,0,0,0,44,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216,64V192H88V64Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,1,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM68,188a12,12,0,1,1,12-12A12,12,0,0,1,68,188Zm0-48a12,12,0,1,1,12-12A12,12,0,0,1,68,140Zm0-48A12,12,0,1,1,80,80,12,12,0,0,1,68,92Zm124,92H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Zm0-48H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Zm0-48H104a8,8,0,0,1,0-16h88a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M82,64a6,6,0,0,1,6-6H216a6,6,0,0,1,0,12H88A6,6,0,0,1,82,64Zm134,58H88a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Zm0,64H88a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12ZM44,54A10,10,0,1,0,54,64,10,10,0,0,0,44,54Zm0,128a10,10,0,1,0,10,10A10,10,0,0,0,44,182Zm0-64a10,10,0,1,0,10,10A10,10,0,0,0,44,118Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M84,64a4,4,0,0,1,4-4H216a4,4,0,0,1,0,8H88A4,4,0,0,1,84,64Zm132,60H88a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Zm0,64H88a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8ZM44,120a8,8,0,1,0,8,8A8,8,0,0,0,44,120Zm0-64a8,8,0,1,0,8,8A8,8,0,0,0,44,56Zm0,128a8,8,0,1,0,8,8A8,8,0,0,0,44,184Z" }))
  ]
]), Ia = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H116a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM116,76H216a12,12,0,0,0,0-24H116a12,12,0,0,0,0,24ZM216,180H116a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24ZM44,59.31V104a12,12,0,0,0,24,0V40A12,12,0,0,0,50.64,29.27l-16,8a12,12,0,0,0,9.36,22Zm39.73,96.86a27.7,27.7,0,0,0-11.2-18.63A28.89,28.89,0,0,0,32.9,143a27.71,27.71,0,0,0-4.17,7.54,12,12,0,0,0,22.55,8.21,4,4,0,0,1,.58-1,4.78,4.78,0,0,1,6.5-.82,3.82,3.82,0,0,1,1.61,2.6,3.63,3.63,0,0,1-.77,2.77l-.13.17L30.39,200.82A12,12,0,0,0,40,220H72a12,12,0,0,0,0-24H64l14.28-19.11A27.48,27.48,0,0,0,83.73,156.17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M216,64V192H104V64Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM56.84,75.58a8,8,0,0,1,3.58-10.74l16-8A8,8,0,0,1,88,64v48a8,8,0,0,1-16,0V76.94l-4.42,2.22A8,8,0,0,1,56.84,75.58ZM92,180a8,8,0,0,1,0,16H68a8,8,0,0,1-6.4-12.8l21.67-28.89A3.92,3.92,0,0,0,84,152a4,4,0,0,0-7.77-1.33,8,8,0,0,1-15.09-5.34,20,20,0,1,1,35,18.53L84,180Zm100,4H120a8,8,0,0,1,0-16h72a8,8,0,0,1,0,16Zm0-48H120a8,8,0,0,1,0-16h72a8,8,0,0,1,0,16Zm0-48H120a8,8,0,0,1,0-16h72a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H104a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM104,70H216a6,6,0,0,0,0-12H104a6,6,0,0,0,0,12ZM216,186H104a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12ZM42.68,53.37,50,49.71V104a6,6,0,0,0,12,0V40a6,6,0,0,0-8.68-5.37l-16,8a6,6,0,0,0,5.36,10.74ZM72,202H52l21.48-28.74A21.5,21.5,0,0,0,77.79,157,21.75,21.75,0,0,0,69,142.38a22.86,22.86,0,0,0-31.35,4.31,22.18,22.18,0,0,0-3.28,5.92,6,6,0,0,0,11.28,4.11,9.87,9.87,0,0,1,1.48-2.67,10.78,10.78,0,0,1,14.78-2,9.89,9.89,0,0,1,4,6.61,9.64,9.64,0,0,1-2,7.28l-.06.09L35.2,204.41A6,6,0,0,0,40,214H72a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H104a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM104,68H216a4,4,0,0,0,0-8H104a4,4,0,0,0,0,8ZM216,188H104a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8ZM41.79,51.58,52,46.47V104a4,4,0,0,0,8,0V40a4,4,0,0,0-5.79-3.58l-16,8a4,4,0,1,0,3.58,7.16ZM72,204H48l23.85-31.92a19.54,19.54,0,0,0,4-14.8,19.76,19.76,0,0,0-8-13.28,20.84,20.84,0,0,0-28.59,3.92,19.85,19.85,0,0,0-3,5.38A4,4,0,0,0,43.76,156a12.1,12.1,0,0,1,1.78-3.22,12.78,12.78,0,0,1,17.54-2.37,11.85,11.85,0,0,1,4.81,7.94,11.65,11.65,0,0,1-2.41,8.85L36.8,205.61A4,4,0,0,0,40,212H72a4,4,0,0,0,0-8Z" }))
  ]
]), Ta = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,76H180V56A52,52,0,0,0,76,56V76H48A20,20,0,0,0,28,96V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V96A20,20,0,0,0,208,76ZM100,56a28,28,0,0,1,56,0V76H100ZM204,204H52V100H204Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M216,96V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H208A8,8,0,0,1,216,96Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,82H174V56a46,46,0,0,0-92,0V82H48A14,14,0,0,0,34,96V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V96A14,14,0,0,0,208,82ZM94,56a34,34,0,0,1,68,0V82H94ZM210,208a2,2,0,0,1-2,2H48a2,2,0,0,1-2-2V96a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,84H172V56a44,44,0,0,0-88,0V84H48A12,12,0,0,0,36,96V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V96A12,12,0,0,0,208,84ZM92,56a36,36,0,0,1,72,0V84H92ZM212,208a4,4,0,0,1-4,4H48a4,4,0,0,1-4-4V96a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4Z" }))
  ]
]), xa = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M232.49,215.51,185,168a92.12,92.12,0,1,0-17,17l47.53,47.54a12,12,0,0,0,17-17ZM44,112a68,68,0,1,1,68,68A68.07,68.07,0,0,1,44,112Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M192,112a80,80,0,1,1-80-80A80,80,0,0,1,192,112Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M229.66,218.34,179.6,168.28a88.21,88.21,0,1,0-11.32,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M228.24,219.76l-51.38-51.38a86.15,86.15,0,1,0-8.48,8.48l51.38,51.38a6,6,0,0,0,8.48-8.48ZM38,112a74,74,0,1,1,74,74A74.09,74.09,0,0,1,38,112Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M229.66,218.34l-50.07-50.06a88.11,88.11,0,1,0-11.31,11.31l50.06,50.07a8,8,0,0,0,11.32-11.32ZM40,112a72,72,0,1,1,72,72A72.08,72.08,0,0,1,40,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M226.83,221.17l-52.7-52.7a84.1,84.1,0,1,0-5.66,5.66l52.7,52.7a4,4,0,0,0,5.66-5.66ZM36,112a76,76,0,1,1,76,76A76.08,76.08,0,0,1,36,112Z" }))
  ]
]), Fa = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M238.15,78.54,177.46,17.86a20,20,0,0,0-28.3,0L97.2,70c-12.43-3.33-36.68-5.72-61.74,14.5a20,20,0,0,0-1.6,29.73l45.46,45.47-39.8,39.8a12,12,0,0,0,17,17l39.8-39.81,45.47,45.46A20,20,0,0,0,155.91,228c.46,0,.93,0,1.4-.05A20,20,0,0,0,171.87,220c4.69-6.23,11-16.13,14.44-28s3.45-22.88.16-33.4l51.7-51.87A20,20,0,0,0,238.15,78.54Zm-74.26,68.79a12,12,0,0,0-2.23,13.84c3.43,6.86,6.9,21-6.28,40.65L54.08,100.53c21.09-14.59,39.53-6.64,41-6a11.67,11.67,0,0,0,13.81-2.29l54.43-54.61,55,55Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M229.66,98.34,172.39,155.8c11.46,22.93-1.72,45.86-10.11,57a8,8,0,0,1-12,.83L42.34,105.76A8,8,0,0,1,43,93.85c29.65-23.92,57.4-10,57.4-10l57.27-57.46a8,8,0,0,1,11.31,0L229.66,87A8,8,0,0,1,229.66,98.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M235.32,81.37,174.63,20.69a16,16,0,0,0-22.63,0L98.37,74.49c-10.66-3.34-35-7.37-60.4,13.14a16,16,0,0,0-1.29,23.78L85,159.71,42.34,202.34a8,8,0,0,0,11.32,11.32L96.29,171l48.29,48.29A16,16,0,0,0,155.9,224c.38,0,.75,0,1.13,0a15.93,15.93,0,0,0,11.64-6.33c19.64-26.1,17.75-47.32,13.19-60L235.33,104A16,16,0,0,0,235.32,81.37ZM224,92.69h0l-57.27,57.46a8,8,0,0,0-1.49,9.22c9.46,18.93-1.8,38.59-9.34,48.62L48,100.08c12.08-9.74,23.64-12.31,32.48-12.31A40.13,40.13,0,0,1,96.81,91a8,8,0,0,0,9.25-1.51L163.32,32,224,92.68Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M235.33,104l-53.47,53.65c4.56,12.67,6.45,33.89-13.19,60A15.93,15.93,0,0,1,157,224c-.38,0-.75,0-1.13,0a16,16,0,0,1-11.32-4.69L96.29,171,53.66,213.66a8,8,0,0,1-11.32-11.32L85,159.71l-48.3-48.3A16,16,0,0,1,38,87.63c25.42-20.51,49.75-16.48,60.4-13.14L152,20.7a16,16,0,0,1,22.63,0l60.69,60.68A16,16,0,0,1,235.33,104Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M233.91,82.79,173.22,22.1a14,14,0,0,0-19.81,0L98.93,76.77c-9.52-3.25-34-8.34-59.71,12.41A14,14,0,0,0,38.1,110l49.71,49.71-44.05,44a6,6,0,1,0,8.48,8.48l44.05-44.05L146,217.89a14,14,0,0,0,9.9,4.11q.49,0,1,0a14,14,0,0,0,10.19-5.54c19.72-26.21,17.15-47.23,12.46-59.3l54.37-54.55A14,14,0,0,0,233.91,82.79ZM225.42,94.1h0l-57.27,57.46a6,6,0,0,0-1.11,6.92c9.94,19.88-1.71,40.32-9.54,50.72a2,2,0,0,1-3,.2L46.58,101.51a2,2,0,0,1,.18-3c12.5-10.09,24.5-12.76,33.7-12.76a42.13,42.13,0,0,1,17.25,3.41A6,6,0,0,0,104.64,88L161.9,30.59a2,2,0,0,1,2.83,0l60.69,60.68A2,2,0,0,1,225.42,94.1Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M235.32,81.37,174.63,20.69a16,16,0,0,0-22.63,0L98.37,74.49c-10.66-3.34-35-7.37-60.4,13.14a16,16,0,0,0-1.29,23.78L85,159.71,42.34,202.34a8,8,0,0,0,11.32,11.32L96.29,171l48.29,48.29A16,16,0,0,0,155.9,224c.38,0,.75,0,1.13,0a15.93,15.93,0,0,0,11.64-6.33c19.64-26.1,17.75-47.32,13.19-60L235.33,104A16,16,0,0,0,235.32,81.37ZM224,92.69h0l-57.27,57.46a8,8,0,0,0-1.49,9.22c9.46,18.93-1.8,38.59-9.34,48.62L48,100.08c12.08-9.74,23.64-12.31,32.48-12.31A40.13,40.13,0,0,1,96.81,91a8,8,0,0,0,9.25-1.51L163.32,32,224,92.68Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M232.49,84.2,171.8,23.51a12,12,0,0,0-17,0L99.45,79.07c-8.08-3-32.79-9.45-59,11.67a12,12,0,0,0-1,17.84l51.13,51.13L45.17,205.17a4,4,0,0,0,5.66,5.66l45.46-45.47,51.12,51.12A12,12,0,0,0,155.9,220c.28,0,.57,0,.85,0a12,12,0,0,0,8.73-4.74c19.83-26.36,16.51-47.18,11.71-58.57l55.3-55.49A12,12,0,0,0,232.49,84.2Zm-5.66,11.31h0L169.56,153a4,4,0,0,0-.75,4.61c10.43,20.85-1.62,42-9.73,52.83a4,4,0,0,1-6,.4L45.17,102.93a4,4,0,0,1,.33-6C58.44,86.53,70.86,83.74,80.44,83.74A43.9,43.9,0,0,1,98.6,87.38a4,4,0,0,0,4.62-.75l57.27-57.46a4,4,0,0,1,5.66,0l60.68,60.69A4,4,0,0,1,226.83,95.51Z" }))
  ]
]), Ba = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M185.08,114.46A48,48,0,0,0,148,36H80A12,12,0,0,0,68,48V200a12,12,0,0,0,12,12h80a52,52,0,0,0,25.08-97.54ZM92,60h56a24,24,0,0,1,0,48H92Zm68,128H92V132h68a28,28,0,0,1,0,56Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M200,160a40,40,0,0,1-40,40H80V48h68a36,36,0,0,1,0,72h12A40,40,0,0,1,200,160Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M168,156a20,20,0,0,1-20,20H96V136h52A20,20,0,0,1,168,156ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM184,156a36,36,0,0,0-18-31.15A36,36,0,0,0,140,64H88a8,8,0,0,0-8,8V184a8,8,0,0,0,8,8h60A36,36,0,0,0,184,156Zm-24-56a20,20,0,0,0-20-20H96v40h44A20,20,0,0,0,160,100Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M174.69,116.41A42,42,0,0,0,148,42H80a6,6,0,0,0-6,6V200a6,6,0,0,0,6,6h80a46,46,0,0,0,14.69-89.59ZM86,54h62a30,30,0,0,1,0,60H86Zm74,140H86V126h74a34,34,0,0,1,0,68Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M170.27,117.21A40,40,0,0,0,148,44H80a4,4,0,0,0-4,4V200a4,4,0,0,0,4,4h80a44,44,0,0,0,10.27-86.79ZM84,52h64a32,32,0,0,1,0,64H84Zm76,144H84V124h76a36,36,0,0,1,0,72Z" }))
  ]
]), Da = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M204,56a12,12,0,0,1-12,12H160.65l-40,120H144a12,12,0,0,1,0,24H64a12,12,0,0,1,0-24H95.35l40-120H112a12,12,0,0,1,0-24h80A12,12,0,0,1,204,56Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M192,56,144,200H64L112,56Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM176,80H153.64l-34.29,96H136a8,8,0,0,1,0,16H80a8,8,0,0,1,0-16h22.36l34.29-96H120a8,8,0,0,1,0-16h56a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M198,56a6,6,0,0,1-6,6H156.32l-44,132H144a6,6,0,0,1,0,12H64a6,6,0,0,1,0-12H99.68l44-132H112a6,6,0,0,1,0-12h80A6,6,0,0,1,198,56Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M196,56a4,4,0,0,1-4,4H154.88L109.55,196H144a4,4,0,0,1,0,8H64a4,4,0,0,1,0-8h37.12L146.45,60H112a4,4,0,0,1,0-8h80A4,4,0,0,1,196,56Z" }))
  ]
]), Va = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M204,224a12,12,0,0,1-12,12H64a12,12,0,0,1,0-24H192A12,12,0,0,1,204,224Zm-76-28a68.07,68.07,0,0,0,68-68V56a12,12,0,0,0-24,0v72a44,44,0,0,1-88,0V56a12,12,0,0,0-24,0v72A68.07,68.07,0,0,0,128,196Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M184,56v80a56,56,0,0,1-112,0V56Z", opacity: "0.2" }), /* @__PURE__ */ e.createElement("path", { d: "M200,224a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,224Zm-72-24a64.07,64.07,0,0,0,64-64V56a8,8,0,0,0-16,0v80a48,48,0,0,1-96,0V56a8,8,0,0,0-16,0v80A64.07,64.07,0,0,0,128,200Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM80,72a8,8,0,0,1,16,0v48a32,32,0,0,0,64,0V72a8,8,0,0,1,16,0v48a48,48,0,0,1-96,0Zm96,128H80a8,8,0,0,1,0-16h96a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M198,224a6,6,0,0,1-6,6H64a6,6,0,0,1,0-12H192A6,6,0,0,1,198,224Zm-70-26a62.07,62.07,0,0,0,62-62V56a6,6,0,0,0-12,0v80a50,50,0,0,1-100,0V56a6,6,0,0,0-12,0v80A62.07,62.07,0,0,0,128,198Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M200,224a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,224Zm-72-24a64.07,64.07,0,0,0,64-64V56a8,8,0,0,0-16,0v80a48,48,0,0,1-96,0V56a8,8,0,0,0-16,0v80A64.07,64.07,0,0,0,128,200Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M196,224a4,4,0,0,1-4,4H64a4,4,0,0,1,0-8H192A4,4,0,0,1,196,224Zm-68-28a60.07,60.07,0,0,0,60-60V56a4,4,0,0,0-8,0v80a52,52,0,0,1-104,0V56a4,4,0,0,0-8,0v80A60.07,60.07,0,0,0,128,196Z" }))
  ]
]), Ra = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M240.26,186.1,152.81,34.23h0a28.74,28.74,0,0,0-49.62,0L15.74,186.1a27.45,27.45,0,0,0,0,27.71A28.31,28.31,0,0,0,40.55,228h174.9a28.31,28.31,0,0,0,24.79-14.19A27.45,27.45,0,0,0,240.26,186.1Zm-20.8,15.7a4.46,4.46,0,0,1-4,2.2H40.55a4.46,4.46,0,0,1-4-2.2,3.56,3.56,0,0,1,0-3.73L124,46.2a4.77,4.77,0,0,1,8,0l87.44,151.87A3.56,3.56,0,0,1,219.46,201.8ZM116,136V104a12,12,0,0,1,24,0v32a12,12,0,0,1-24,0Zm28,40a16,16,0,1,1-16-16A16,16,0,0,1,144,176Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M215.46,216H40.54C27.92,216,20,202.79,26.13,192.09L113.59,40.22c6.3-11,22.52-11,28.82,0l87.46,151.87C236,202.79,228.08,216,215.46,216Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M235.07,189.09,147.61,37.22h0a22.75,22.75,0,0,0-39.22,0L20.93,189.09a21.53,21.53,0,0,0,0,21.72A22.35,22.35,0,0,0,40.55,222h174.9a22.35,22.35,0,0,0,19.6-11.19A21.53,21.53,0,0,0,235.07,189.09ZM224.66,204.8a10.46,10.46,0,0,1-9.21,5.2H40.55a10.46,10.46,0,0,1-9.21-5.2,9.51,9.51,0,0,1,0-9.72L118.79,43.21a10.75,10.75,0,0,1,18.42,0l87.46,151.87A9.51,9.51,0,0,1,224.66,204.8ZM122,144V104a6,6,0,0,1,12,0v40a6,6,0,0,1-12,0Zm16,36a10,10,0,1,1-10-10A10,10,0,0,1,138,180Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M233.34,190.09,145.88,38.22h0a20.75,20.75,0,0,0-35.76,0L22.66,190.09a19.52,19.52,0,0,0,0,19.71A20.36,20.36,0,0,0,40.54,220H215.46a20.36,20.36,0,0,0,17.86-10.2A19.52,19.52,0,0,0,233.34,190.09ZM226.4,205.8a12.47,12.47,0,0,1-10.94,6.2H40.54a12.47,12.47,0,0,1-10.94-6.2,11.45,11.45,0,0,1,0-11.72L117.05,42.21a12.76,12.76,0,0,1,21.9,0L226.4,194.08A11.45,11.45,0,0,1,226.4,205.8ZM124,144V104a4,4,0,0,1,8,0v40a4,4,0,0,1-8,0Zm12,36a8,8,0,1,1-8-8A8,8,0,0,1,136,180Z" }))
  ]
]), Pa = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M116,132V80a12,12,0,0,1,24,0v52a12,12,0,0,1-24,0ZM236,91.55v72.9a19.86,19.86,0,0,1-5.86,14.14l-51.55,51.55A19.85,19.85,0,0,1,164.45,236H91.55a19.85,19.85,0,0,1-14.14-5.86L25.86,178.59A19.86,19.86,0,0,1,20,164.45V91.55a19.86,19.86,0,0,1,5.86-14.14L77.41,25.86A19.85,19.85,0,0,1,91.55,20h72.9a19.85,19.85,0,0,1,14.14,5.86l51.55,51.55A19.86,19.86,0,0,1,236,91.55Zm-24,1.66L162.79,44H93.21L44,93.21v69.58L93.21,212h69.58L212,162.79ZM128,156a16,16,0,1,0,16,16A16,16,0,0,0,128,156Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M224,91.55v72.9a8,8,0,0,1-2.34,5.66l-51.55,51.55a8,8,0,0,1-5.66,2.34H91.55a8,8,0,0,1-5.66-2.34L34.34,170.11A8,8,0,0,1,32,164.45V91.55a8,8,0,0,1,2.34-5.66L85.89,34.34A8,8,0,0,1,91.55,32h72.9a8,8,0,0,1,5.66,2.34l51.55,51.55A8,8,0,0,1,224,91.55Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M227.31,80.23,175.77,28.69A16.13,16.13,0,0,0,164.45,24H91.55a16.13,16.13,0,0,0-11.32,4.69L28.69,80.23A16.13,16.13,0,0,0,24,91.55v72.9a16.13,16.13,0,0,0,4.69,11.32l51.54,51.54A16.13,16.13,0,0,0,91.55,232h72.9a16.13,16.13,0,0,0,11.32-4.69l51.54-51.54A16.13,16.13,0,0,0,232,164.45V91.55A16.13,16.13,0,0,0,227.31,80.23ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M122,136V80a6,6,0,0,1,12,0v56a6,6,0,0,1-12,0ZM230,91.55v72.9a13.92,13.92,0,0,1-4.1,9.9L174.35,225.9a13.92,13.92,0,0,1-9.9,4.1H91.55a13.92,13.92,0,0,1-9.9-4.1L30.1,174.35a13.92,13.92,0,0,1-4.1-9.9V91.55a13.92,13.92,0,0,1,4.1-9.9L81.65,30.1a13.92,13.92,0,0,1,9.9-4.1h72.9a13.92,13.92,0,0,1,9.9,4.1L225.9,81.65A13.92,13.92,0,0,1,230,91.55Zm-12,0a2,2,0,0,0-.59-1.42L165.87,38.59a2,2,0,0,0-1.42-.59H91.55a2,2,0,0,0-1.41.59L38.58,90.13A2,2,0,0,0,38,91.55v72.9a2,2,0,0,0,.59,1.42l51.54,51.54a2,2,0,0,0,1.42.59h72.9a2,2,0,0,0,1.41-.59l51.56-51.54a2,2,0,0,0,.58-1.42ZM128,162a10,10,0,1,0,10,10A10,10,0,0,0,128,162Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M124,136V80a4,4,0,0,1,8,0v56a4,4,0,0,1-8,0ZM228,91.55v72.9a12,12,0,0,1-3.51,8.49l-51.55,51.55a12,12,0,0,1-8.49,3.51H91.55a12,12,0,0,1-8.49-3.51L31.51,172.94A12,12,0,0,1,28,164.45V91.55a12,12,0,0,1,3.51-8.49L83.06,31.51A12,12,0,0,1,91.55,28h72.9a12,12,0,0,1,8.49,3.51l51.55,51.55A12,12,0,0,1,228,91.55Zm-8,0a4,4,0,0,0-1.17-2.83L167.28,37.17A4.06,4.06,0,0,0,164.45,36H91.55a4.06,4.06,0,0,0-2.83,1.17L37.17,88.72A4,4,0,0,0,36,91.55v72.9a4,4,0,0,0,1.17,2.83l51.55,51.55A4.06,4.06,0,0,0,91.55,220h72.9a4.06,4.06,0,0,0,2.83-1.17l51.55-51.55a4,4,0,0,0,1.17-2.83ZM128,164a8,8,0,1,0,8,8A8,8,0,0,0,128,164Z" }))
  ]
]), za = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ e.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("path", { d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z" }))
  ]
]), Tt = Ye({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), P = e.forwardRef(
  (n, a) => {
    const {
      alt: l,
      color: o,
      size: r,
      weight: c,
      mirrored: s,
      children: d,
      weights: i,
      ...h
    } = n, {
      color: _ = "currentColor",
      size: u,
      weight: g = "regular",
      mirrored: N = !1,
      ...E
    } = e.useContext(Tt);
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        ref: a,
        xmlns: "http://www.w3.org/2000/svg",
        width: r ?? u,
        height: r ?? u,
        fill: o ?? _,
        viewBox: "0 0 256 256",
        transform: s || N ? "scale(-1, 1)" : void 0,
        ...E,
        ...h
      },
      !!l && /* @__PURE__ */ e.createElement("title", null, l),
      d,
      i.get(c ?? g)
    );
  }
);
P.displayName = "IconBase";
const st = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: va }));
st.displayName = "ArrowLeftIcon";
const Fe = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: $a }));
Fe.displayName = "CaretDownIcon";
const Ht = Fe, Et = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Aa }));
Et.displayName = "CaretLeftIcon";
const wt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Na }));
wt.displayName = "CaretRightIcon";
const Zt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Ea }));
Zt.displayName = "CaretUpIcon";
const Oa = Zt, xt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: wa }));
xt.displayName = "CaretUpDownIcon";
const Ft = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Za }));
Ft.displayName = "CheckIcon";
const Bt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Ma }));
Bt.displayName = "CheckCircleIcon";
const Dt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: ya }));
Dt.displayName = "CloudArrowUpIcon";
const Vt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: La }));
Vt.displayName = "DotsSixVerticalIcon";
const Rt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Ha }));
Rt.displayName = "FileImageIcon";
const Pt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Ca }));
Pt.displayName = "InfoIcon";
const zt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: ka }));
zt.displayName = "LinkSimpleIcon";
const Ot = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Sa }));
Ot.displayName = "ListBulletsIcon";
const Wt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Ia }));
Wt.displayName = "ListNumbersIcon";
const Gt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Ta }));
Gt.displayName = "LockSimpleIcon";
const Ut = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: xa }));
Ut.displayName = "MagnifyingGlassIcon";
const Kt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Fa }));
Kt.displayName = "PushPinIcon";
const Xt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Ba }));
Xt.displayName = "TextBIcon";
const Yt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Da }));
Yt.displayName = "TextItalicIcon";
const qt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Va }));
qt.displayName = "TextUnderlineIcon";
const jt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Ra }));
jt.displayName = "WarningIcon";
const Jt = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: Pa }));
Jt.displayName = "WarningOctagonIcon";
const ne = e.forwardRef((n, a) => /* @__PURE__ */ e.createElement(P, { ref: a, ...n, weights: za }));
ne.displayName = "XIcon";
const Wa = "Panel-module__panel___ODFSU", Ga = "Panel-module__header___Thenl", Ua = "Panel-module__headerStart___baSnW", Ka = "Panel-module__heading___oiM9o", Xa = "Panel-module__headingGroup___TeqfT", Ya = "Panel-module__headingPrefix___XB6nz", qa = "Panel-module__subtitle___hINzg", ja = "Panel-module__actions___ox3dn", Ja = "Panel-module__back___-CSI4", Qa = "Panel-module__close___K7NcX", en = "Panel-module__subHeader___No6o7", tn = "Panel-module__content___abEbs", an = "Panel-module__contentFlush___1z4D7", nn = "Panel-module__footer___sp70h", J = {
  panel: Wa,
  header: Ga,
  headerStart: Ua,
  heading: Ka,
  headingGroup: Xa,
  headingPrefix: Ya,
  subtitle: qa,
  actions: ja,
  back: Ja,
  close: Qa,
  subHeader: en,
  content: tn,
  contentFlush: an,
  footer: nn
}, ln = x(
  ({
    heading: n,
    subtitle: a,
    headingPrefix: l,
    headerActions: o,
    subHeader: r,
    onBack: c,
    closable: s,
    onClose: d,
    flush: i,
    minimized: h,
    footer: _,
    children: u,
    className: g,
    style: N,
    ...E
  }, M) => {
    const y = n || a || l || o || s || c, w = S(null), [H, b] = F(!1);
    return U(() => {
      if (i)
        return;
      const v = w.current;
      if (!v)
        return;
      const p = () => b(v.scrollHeight > v.clientHeight);
      p();
      const $ = new ResizeObserver(p);
      return $.observe(v), () => $.disconnect();
    }, [i, u]), /* @__PURE__ */ m(
      "section",
      {
        ref: M,
        "aria-label": typeof n == "string" ? n : void 0,
        className: `${J.panel} ${g ?? ""}`,
        style: h ? { height: "auto", ...N } : N,
        ...E,
        children: [
          y && /* @__PURE__ */ m("header", { className: J.header, children: [
            /* @__PURE__ */ m("div", { className: J.headerStart, children: [
              c && /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  "aria-label": "Tilbake",
                  onClick: c,
                  className: J.back,
                  children: /* @__PURE__ */ t(st, { size: 16, weight: "bold" })
                }
              ),
              (n || a || l) && /* @__PURE__ */ m("div", { className: J.headingGroup, children: [
                l && /* @__PURE__ */ t("div", { className: J.headingPrefix, children: l }),
                n && /* @__PURE__ */ t("h2", { className: J.heading, children: n }),
                a && /* @__PURE__ */ t("div", { className: J.subtitle, children: a })
              ] })
            ] }),
            /* @__PURE__ */ m("div", { className: J.actions, children: [
              o,
              s && /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  "aria-label": "Lukk",
                  onClick: d,
                  className: J.close,
                  children: /* @__PURE__ */ t(ne, { size: 16, weight: "bold" })
                }
              )
            ] })
          ] }),
          r && /* @__PURE__ */ t("div", { "data-panel-subheader": !0, className: J.subHeader, children: r }),
          !h && /* @__PURE__ */ t(
            "div",
            {
              ref: w,
              className: i ? J.contentFlush : J.content,
              tabIndex: H ? 0 : void 0,
              children: u
            }
          ),
          _ && /* @__PURE__ */ t("footer", { className: J.footer, children: _ })
        ]
      }
    );
  }
);
ln.displayName = "Panel";
const on = "Block-module__block___QqcBU", rn = "Block-module__open___a8cTi", cn = "Block-module__trigger___GG43J", sn = "Block-module__heading___Tvwph", dn = "Block-module__indicator___scr4v", _n = "Block-module__contentWrapper___Mv-rl", mn = "Block-module__content___TtVra", be = {
  block: on,
  open: rn,
  trigger: cn,
  heading: sn,
  indicator: dn,
  contentWrapper: _n,
  content: mn
};
function p2({
  heading: n,
  defaultOpen: a = !1,
  children: l,
  className: o
}) {
  const c = `${W()}-content`, [s, d] = F(a);
  return /* @__PURE__ */ m("section", { className: `${be.block} ${s ? be.open : ""} ${o ?? ""}`, children: [
    /* @__PURE__ */ m(
      "button",
      {
        type: "button",
        "aria-expanded": s,
        "aria-controls": c,
        onClick: () => d(!s),
        className: be.trigger,
        children: [
          /* @__PURE__ */ t("span", { className: be.heading, children: n }),
          /* @__PURE__ */ t(Fe, { size: 16, weight: "bold", className: be.indicator, "aria-hidden": "true" })
        ]
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        id: c,
        role: "region",
        className: be.contentWrapper,
        children: /* @__PURE__ */ t("div", { className: be.content, children: l })
      }
    )
  ] });
}
const un = "Accordion-module__accordion___FBCe9", pn = "Accordion-module__item___8o5k3", hn = "Accordion-module__open___EZa8M", gn = "Accordion-module__headingWrapper___V6IO5", bn = "Accordion-module__trigger___Yzl3t", fn = "Accordion-module__headingText___yZokZ", vn = "Accordion-module__heading___7sMz3", $n = "Accordion-module__subtitle___uWd0g", An = "Accordion-module__actions___VF5zK", Nn = "Accordion-module__indicator___6Way3", En = "Accordion-module__contentWrapper___sCCBw", wn = "Accordion-module__content___3FnKx", te = {
  accordion: un,
  item: pn,
  open: hn,
  headingWrapper: gn,
  trigger: bn,
  headingText: fn,
  heading: vn,
  subtitle: $n,
  actions: An,
  indicator: Nn,
  contentWrapper: En,
  content: wn
};
function h2({ items: n, multiple: a = !1, defaultOpenItems: l, className: o }) {
  const r = W(), [c, s] = F(new Set(l)), d = (i) => {
    s((h) => {
      const _ = new Set(a ? h : []);
      return h.has(i) ? _.delete(i) : _.add(i), _;
    });
  };
  return /* @__PURE__ */ t("div", { className: `${te.accordion} ${o ?? ""}`, children: n.map((i) => {
    const h = c.has(i.id), _ = `${r}-${i.id}-content`, u = `${r}-${i.id}-trigger`;
    return /* @__PURE__ */ m(
      "div",
      {
        className: `${te.item} ${h ? te.open : ""}`,
        children: [
          /* @__PURE__ */ m("h3", { className: te.headingWrapper, children: [
            /* @__PURE__ */ m(
              "button",
              {
                id: u,
                type: "button",
                "aria-expanded": h,
                "aria-controls": _,
                onClick: () => d(i.id),
                className: te.trigger,
                children: [
                  /* @__PURE__ */ m("span", { className: te.headingText, children: [
                    /* @__PURE__ */ t("span", { className: te.heading, children: i.heading }),
                    i.subtitle && /* @__PURE__ */ t("span", { className: te.subtitle, children: i.subtitle })
                  ] }),
                  /* @__PURE__ */ t(Fe, { size: 16, weight: "bold", className: te.indicator, "aria-hidden": "true" })
                ]
              }
            ),
            i.actions && /* @__PURE__ */ t("div", { className: te.actions, onClick: (g) => g.stopPropagation(), children: i.actions })
          ] }),
          /* @__PURE__ */ t(
            "div",
            {
              id: _,
              role: "region",
              "aria-labelledby": u,
              className: te.contentWrapper,
              children: /* @__PURE__ */ t("div", { className: te.content, children: i.content })
            }
          )
        ]
      },
      i.id
    );
  }) });
}
const Zn = "ActionBar-module__bar___nhW9w", Mn = "ActionBar-module__horizontal___ZmKMM", yn = "ActionBar-module__vertical___O06CR", Ln = "ActionBar-module__group___PsHBA", gt = {
  bar: Zn,
  horizontal: Mn,
  vertical: yn,
  group: Ln
};
function g2({
  children: n,
  orientation: a = "horizontal",
  label: l,
  className: o
}) {
  return /* @__PURE__ */ t(
    "nav",
    {
      "aria-label": l,
      className: `${gt.bar} ${gt[a]} ${o ?? ""}`,
      children: n
    }
  );
}
function b2({ children: n, label: a, className: l }) {
  return /* @__PURE__ */ t(
    "div",
    {
      role: "group",
      "aria-label": a,
      className: `${gt.group} ${l ?? ""}`,
      children: n
    }
  );
}
const Hn = "BackButton-module__backButton___PNPrQ", Cn = "BackButton-module__iconSlot___9dXLc", kn = "BackButton-module__icon___SsDA7", Sn = "BackButton-module__label___ZHa5M", et = {
  backButton: Hn,
  iconSlot: Cn,
  icon: kn,
  label: Sn
};
function f2({ children: n, className: a, ...l }) {
  const o = `${et.backButton} ${a ?? ""}`, r = /* @__PURE__ */ m(re, { children: [
    /* @__PURE__ */ t("span", { className: et.iconSlot, "aria-hidden": "true", children: /* @__PURE__ */ t(Et, { size: 16, weight: "bold", className: et.icon }) }),
    /* @__PURE__ */ t("span", { className: et.label, children: n })
  ] });
  return "href" in l && l.href !== void 0 ? /* @__PURE__ */ t("a", { className: o, ...l, children: r }) : /* @__PURE__ */ t("button", { type: "button", className: o, ...l, children: r });
}
const In = "FilterPanel-module__panel___UJqWy", Tn = "FilterPanel-module__fields___yXidK", xn = "FilterPanel-module__footer___JnxH4", Fn = "FilterPanel-module__resetButton___cp37b", Bn = "FilterPanel-module__badge___einbe", Ve = {
  panel: In,
  fields: Tn,
  footer: xn,
  resetButton: Fn,
  badge: Bn
};
function v2({
  children: n,
  activeCount: a = 0,
  onReset: l,
  resetLabel: o = "Fjern alle filter",
  className: r
}) {
  const c = a > 0;
  return /* @__PURE__ */ m("div", { className: `${Ve.panel} ${r ?? ""}`, children: [
    /* @__PURE__ */ t("div", { className: Ve.fields, children: n }),
    c && l && /* @__PURE__ */ m("div", { className: Ve.footer, children: [
      /* @__PURE__ */ t("button", { type: "button", onClick: l, className: Ve.resetButton, children: o }),
      /* @__PURE__ */ t("span", { className: Ve.badge, "aria-label": `${a} aktive filter`, children: a })
    ] })
  ] });
}
const Dn = "TextInput-module__wrapper___2SrO0", Vn = "TextInput-module__label___MdN8i", Rn = "TextInput-module__inputWrapper___JQtT7", Pn = "TextInput-module__input___0nWku", zn = "TextInput-module__sm___4HgOG", On = "TextInput-module__md___PGdmQ", Wn = "TextInput-module__lg___NZ581", Gn = "TextInput-module__prefix___D7LKA", Un = "TextInput-module__suffix___kuWce", Kn = "TextInput-module__hasError___86XIp", Xn = "TextInput-module__error___dhh5d", Yn = "TextInput-module__helperText___6k-Mj", Y = {
  wrapper: Dn,
  label: Vn,
  inputWrapper: Rn,
  input: Pn,
  sm: zn,
  md: On,
  lg: Wn,
  prefix: Gn,
  suffix: Un,
  hasError: Kn,
  error: Xn,
  helperText: Yn
}, Mt = x(
  ({ label: n, helperText: a, error: l, prefix: o, suffix: r, size: c = "lg", hideLabel: s = !1, className: d, id: i, ...h }, _) => {
    const u = W(), g = i ?? u, N = `${g}-helper`, E = `${g}-error`, M = S(null), y = _ ?? M, w = T(() => {
      y.current?.focus();
    }, [y]);
    return /* @__PURE__ */ m("div", { className: `${Y.wrapper} ${Y[c]} ${l ? Y.hasError : ""} ${d ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: g, className: `${Y.label} ${s ? "sr-only" : ""}`, children: n }),
      /* @__PURE__ */ m("div", { className: Y.inputWrapper, onClick: w, children: [
        o && /* @__PURE__ */ t("span", { className: Y.prefix, children: o }),
        /* @__PURE__ */ t(
          "input",
          {
            ref: y,
            id: g,
            type: "text",
            "aria-describedby": l ? E : a ? N : void 0,
            "aria-invalid": l ? !0 : void 0,
            className: Y.input,
            ...h
          }
        ),
        r && /* @__PURE__ */ t("span", { className: Y.suffix, children: r })
      ] }),
      l && /* @__PURE__ */ t("p", { id: E, className: Y.error, role: "alert", children: l }),
      a && !l && /* @__PURE__ */ t("p", { id: N, className: Y.helperText, children: a })
    ] });
  }
);
Mt.displayName = "TextInput";
const qn = "SearchInput-module__clearButton___i1i4v", jn = {
  clearButton: qn
}, Jn = x(
  ({
    label: n,
    value: a,
    onChange: l,
    onClear: o,
    placeholder: r = "Søk…",
    hideLabel: c = !1,
    size: s = "lg",
    autoFocus: d,
    className: i,
    autoComplete: h = "off"
  }, _) => {
    const u = (N) => {
      l(N.target.value);
    }, g = () => {
      o ? o() : l("");
    };
    return /* @__PURE__ */ t(
      Mt,
      {
        ref: _,
        label: n,
        hideLabel: c,
        type: "text",
        value: a,
        onChange: u,
        placeholder: r,
        size: s,
        autoFocus: d,
        className: i,
        spellCheck: !1,
        autoComplete: h,
        prefix: /* @__PURE__ */ t(
          Ut,
          {
            size: s === "sm" ? 14 : 16,
            weight: "duotone",
            "aria-hidden": "true"
          }
        ),
        suffix: a.length > 0 ? /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            onClick: g,
            "aria-label": "Tøm søk",
            className: jn.clearButton,
            children: /* @__PURE__ */ t(
              ne,
              {
                size: s === "sm" ? 12 : 14,
                "aria-hidden": "true"
              }
            )
          }
        ) : void 0
      }
    );
  }
);
Jn.displayName = "SearchInput";
const Qn = "NumberInput-module__wrapper___X3u87", e0 = "NumberInput-module__label___r4RW9", t0 = "NumberInput-module__inputWrapper___mnbm8", a0 = "NumberInput-module__sm___12wQu", n0 = "NumberInput-module__md___kApTJ", l0 = "NumberInput-module__lg___HnFuX", o0 = "NumberInput-module__input___XO0Ym", r0 = "NumberInput-module__prefix___e3gQ-", c0 = "NumberInput-module__unit___Tio-N", s0 = "NumberInput-module__hasError___UK5Yo", i0 = "NumberInput-module__error___DXmBn", d0 = "NumberInput-module__helperText___vvsC0", oe = {
  wrapper: Qn,
  label: e0,
  inputWrapper: t0,
  sm: a0,
  md: n0,
  lg: l0,
  input: o0,
  prefix: r0,
  unit: c0,
  hasError: s0,
  error: i0,
  helperText: d0
}, _0 = x(
  ({ label: n, helperText: a, error: l, unit: o, prefix: r, size: c = "lg", hideLabel: s = !1, className: d, id: i, ...h }, _) => {
    const u = W(), g = i ?? u, N = `${g}-helper`, E = `${g}-error`;
    return /* @__PURE__ */ m("div", { className: `${oe.wrapper} ${oe[c]} ${l ? oe.hasError : ""} ${d ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: g, className: `${oe.label} ${s ? "sr-only" : ""}`, children: n }),
      /* @__PURE__ */ m("div", { className: oe.inputWrapper, children: [
        r && /* @__PURE__ */ t("span", { className: oe.prefix, "aria-hidden": "true", children: r }),
        /* @__PURE__ */ t(
          "input",
          {
            ref: _,
            id: g,
            type: "number",
            "aria-describedby": l ? E : a ? N : void 0,
            "aria-invalid": l ? !0 : void 0,
            className: oe.input,
            ...h
          }
        ),
        o && /* @__PURE__ */ t("span", { className: oe.unit, "aria-hidden": "true", children: o })
      ] }),
      l && /* @__PURE__ */ t("p", { id: E, className: oe.error, role: "alert", children: l }),
      a && !l && /* @__PURE__ */ t("p", { id: N, className: oe.helperText, children: a })
    ] });
  }
);
_0.displayName = "NumberInput";
const m0 = "TextArea-module__wrapper___8B55y", u0 = "TextArea-module__label___lzSBE", p0 = "TextArea-module__textarea___wIdGy", h0 = "TextArea-module__hasError___d1Kqf", g0 = "TextArea-module__error___m477-", b0 = "TextArea-module__helperText___SJrpF", fe = {
  wrapper: m0,
  label: u0,
  textarea: p0,
  hasError: h0,
  error: g0,
  helperText: b0
}, f0 = x(
  ({ label: n, helperText: a, helperTextPosition: l = "below", error: o, hideLabel: r = !1, className: c, id: s, ...d }, i) => {
    const h = W(), _ = s ?? h, u = `${_}-helper`, g = `${_}-error`;
    return /* @__PURE__ */ m("div", { className: `${fe.wrapper} ${o ? fe.hasError : ""} ${c ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: _, className: `${fe.label} ${r ? "sr-only" : ""}`, children: n }),
      l === "above" && a && !o && /* @__PURE__ */ t("p", { id: u, className: fe.helperText, children: a }),
      /* @__PURE__ */ t(
        "textarea",
        {
          ref: i,
          id: _,
          "aria-describedby": o ? g : a ? u : void 0,
          "aria-invalid": o ? !0 : void 0,
          className: fe.textarea,
          ...d
        }
      ),
      o && /* @__PURE__ */ t("p", { id: g, className: fe.error, role: "alert", children: o }),
      l === "below" && a && !o && /* @__PURE__ */ t("p", { id: u, className: fe.helperText, children: a })
    ] });
  }
);
f0.displayName = "TextArea";
const v0 = x(
  ({ label: n, helperText: a, error: l, size: o = "lg", hideLabel: r = !1, className: c, id: s, ...d }, i) => {
    const h = W(), _ = s ?? h, u = `${_}-helper`, g = `${_}-error`;
    return /* @__PURE__ */ m("div", { className: `${Y.wrapper} ${Y[o]} ${l ? Y.hasError : ""} ${c ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: _, className: `${Y.label} ${r ? "sr-only" : ""}`, children: n }),
      /* @__PURE__ */ t("div", { className: Y.inputWrapper, children: /* @__PURE__ */ t(
        "input",
        {
          ref: i,
          id: _,
          type: "date",
          "aria-describedby": l ? g : a ? u : void 0,
          "aria-invalid": l ? !0 : void 0,
          className: Y.input,
          ...d
        }
      ) }),
      l && /* @__PURE__ */ t("p", { id: g, className: Y.error, role: "alert", children: l }),
      a && !l && /* @__PURE__ */ t("p", { id: u, className: Y.helperText, children: a })
    ] });
  }
);
v0.displayName = "DateInput";
const $0 = "Select-module__wrapper___Hr3x4", A0 = "Select-module__label___afWH7", N0 = "Select-module__select___iBXFK", E0 = "Select-module__sm___XCymK", w0 = "Select-module__md___rmkbv", Z0 = "Select-module__lg___T0fSD", M0 = "Select-module__hasError___QhkGe", y0 = "Select-module__error___P7VMK", L0 = "Select-module__helperText___t7Bvu", ve = {
  wrapper: $0,
  label: A0,
  select: N0,
  sm: E0,
  md: w0,
  lg: Z0,
  hasError: M0,
  error: y0,
  helperText: L0
};
function H0(n) {
  return "options" in n;
}
const C0 = x(
  ({ label: n, options: a, placeholder: l, helperText: o, error: r, size: c = "lg", hideLabel: s = !1, className: d, id: i, ...h }, _) => {
    const u = W(), g = i ?? u, N = `${g}-helper`, E = `${g}-error`;
    return /* @__PURE__ */ m("div", { className: `${ve.wrapper} ${ve[c]} ${r ? ve.hasError : ""} ${d ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: g, className: `${ve.label} ${s ? "sr-only" : ""}`, children: n }),
      /* @__PURE__ */ m(
        "select",
        {
          ref: _,
          id: g,
          "aria-describedby": r ? E : o ? N : void 0,
          "aria-invalid": r ? !0 : void 0,
          className: ve.select,
          ...h,
          children: [
            l && /* @__PURE__ */ t("option", { value: "", disabled: !0, children: l }),
            a.map(
              (M) => H0(M) ? /* @__PURE__ */ t("optgroup", { label: M.label, children: M.options.map((y) => /* @__PURE__ */ t("option", { value: y.value, disabled: y.disabled, children: y.label }, y.value)) }, M.label) : /* @__PURE__ */ t("option", { value: M.value, disabled: M.disabled, children: M.label }, M.value)
            )
          ]
        }
      ),
      r && /* @__PURE__ */ t("p", { id: E, className: ve.error, role: "alert", children: r }),
      o && !r && /* @__PURE__ */ t("p", { id: N, className: ve.helperText, children: o })
    ] });
  }
);
C0.displayName = "Select";
const k0 = "Combobox-module__wrapper___dCKez", S0 = "Combobox-module__label___gVBKv", I0 = "Combobox-module__inputContainer___YWHw9", T0 = "Combobox-module__sm___SdhIF", x0 = "Combobox-module__md___QBwW-", F0 = "Combobox-module__lg___xxAMI", B0 = "Combobox-module__inputScroll___u4rwJ", D0 = "Combobox-module__chip___opBY8", V0 = "Combobox-module__chipRemove___d3h-W", R0 = "Combobox-module__input___VscwS", P0 = "Combobox-module__actions___ZnAY8", z0 = "Combobox-module__actionBtn___u1TaG", O0 = "Combobox-module__chevron___Jw3IR", W0 = "Combobox-module__chevronOpen___ZSs-4", G0 = "Combobox-module__portalListbox___LBS0M", U0 = "Combobox-module__portalListboxGrid___GXIja", K0 = "Combobox-module__optionGrid___h6XnC", X0 = "Combobox-module__option___MN0kX", Y0 = "Combobox-module__active___jNw-2", q0 = "Combobox-module__optionCheckbox___MqySp", j0 = "Combobox-module__optionCheckboxChecked___SoiJl", J0 = "Combobox-module__optionLabel___G2gGz", Q0 = "Combobox-module__selected___iULBn", el = "Combobox-module__empty___v6wmo", tl = "Combobox-module__hasError___ZxC2n", al = "Combobox-module__error___EXB46", R = {
  wrapper: k0,
  label: S0,
  inputContainer: I0,
  sm: T0,
  md: x0,
  lg: F0,
  inputScroll: B0,
  chip: D0,
  chipRemove: V0,
  input: R0,
  actions: P0,
  actionBtn: z0,
  chevron: O0,
  chevronOpen: W0,
  portalListbox: G0,
  portalListboxGrid: U0,
  optionGrid: K0,
  option: X0,
  active: Y0,
  optionCheckbox: q0,
  optionCheckboxChecked: j0,
  optionLabel: J0,
  selected: Q0,
  empty: el,
  hasError: tl,
  error: al
}, nl = x(
  ({
    label: n,
    options: a,
    value: l = [],
    onChange: o,
    placeholder: r = "Søk…",
    multiple: c = !1,
    disabled: s = !1,
    error: d,
    size: i = "lg",
    hideLabel: h = !1,
    className: _,
    renderOption: u,
    optionsLayout: g = "list"
  }, N) => {
    const E = W(), M = `${E}-input`, y = `${E}-listbox`, w = `${E}-error`, H = S(null), b = S(null), v = S(null), [p, $] = F(!1), [A, Z] = F(""), [f, C] = F(-1), [k, G] = F({ top: 0, left: 0, width: 0 }), B = a.filter(
      (L) => L.label.toLowerCase().includes(A.toLowerCase())
    ), ce = (L) => l.includes(L), _e = T(
      (L) => {
        o && (c ? o(
          ce(L) ? l.filter((V) => V !== L) : [...l, L]
        ) : (o([L]), $(!1), Z("")));
      },
      [c, o, l]
    ), Be = (L) => {
      switch (L.key) {
        case "ArrowDown":
          L.preventDefault(), $(!0), C((V) => Math.min(V + 1, B.length - 1));
          break;
        case "ArrowUp":
          L.preventDefault(), C((V) => Math.max(V - 1, 0));
          break;
        case "Enter":
          L.preventDefault(), f >= 0 && B[f] && _e(B[f].value);
          break;
        case "Escape":
          $(!1), Z(""), H.current?.focus();
          break;
        case "Home":
          p && (L.preventDefault(), C(0));
          break;
        case "End":
          p && (L.preventDefault(), C(B.length - 1));
          break;
      }
    };
    U(() => {
      p || C(-1);
    }, [p]), U(() => {
      f >= 0 && b.current && b.current.children[f]?.scrollIntoView({ block: "nearest" });
    }, [f]);
    const K = T(() => {
      const L = v.current;
      if (!L)
        return;
      const V = L.getBoundingClientRect(), ee = 4, me = b.current?.getBoundingClientRect().height ?? 0;
      let De = V.bottom + ee;
      me && De + me > window.innerHeight - 8 && (De = V.top - me - ee), G({ top: De, left: V.left, width: V.width });
    }, []);
    At(() => {
      p && K();
    }, [p, B.length, K]), U(() => {
      if (p)
        return window.addEventListener("scroll", K, !0), window.addEventListener("resize", K), () => {
          window.removeEventListener("scroll", K, !0), window.removeEventListener("resize", K);
        };
    }, [p, K]);
    const we = a.filter((L) => l.includes(L.value)), je = l.length > 0, I = !c && je && !A ? we[0]?.label ?? "" : A;
    return /* @__PURE__ */ m(
      "div",
      {
        ref: N,
        className: `${R.wrapper} ${d ? R.hasError : ""} ${_ ?? ""}`,
        onBlur: (L) => {
          L.currentTarget.contains(L.relatedTarget) || ($(!1), Z(""));
        },
        children: [
          /* @__PURE__ */ t("label", { id: `${E}-label`, htmlFor: M, className: `${R.label} ${h ? "sr-only" : ""}`, children: n }),
          /* @__PURE__ */ m("div", { ref: v, className: `${R.inputContainer} ${R[i]}`, children: [
            /* @__PURE__ */ m(
              "div",
              {
                className: R.inputScroll,
                onClick: () => H.current?.focus(),
                children: [
                  c && we.map((L) => /* @__PURE__ */ m("span", { className: R.chip, children: [
                    L.label,
                    /* @__PURE__ */ t(
                      "button",
                      {
                        type: "button",
                        "aria-label": `Fjern ${L.label}`,
                        onClick: (V) => {
                          V.stopPropagation(), _e(L.value);
                        },
                        className: R.chipRemove,
                        children: /* @__PURE__ */ t(ne, { size: 10, weight: "bold" })
                      }
                    )
                  ] }, L.value)),
                  /* @__PURE__ */ t(
                    "input",
                    {
                      ref: H,
                      id: M,
                      type: "text",
                      role: "combobox",
                      "aria-expanded": !!p,
                      "aria-controls": y,
                      "aria-activedescendant": f >= 0 ? `${E}-option-${f}` : void 0,
                      "aria-describedby": d ? w : void 0,
                      "aria-invalid": !!d,
                      "aria-autocomplete": "list",
                      disabled: s,
                      placeholder: we.length > 0 ? "" : r,
                      value: I,
                      onChange: (L) => {
                        Z(L.target.value), $(!0), C(-1);
                      },
                      onFocus: () => $(!0),
                      onKeyDown: Be,
                      className: R.input
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ m("div", { className: R.actions, children: [
              je && /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  "aria-label": "Tøm valg",
                  className: R.actionBtn,
                  onMouseDown: (L) => L.preventDefault(),
                  onClick: () => {
                    o?.([]), Z(""), H.current?.focus();
                  },
                  children: /* @__PURE__ */ t(ne, { size: 14 })
                }
              ),
              /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  "aria-label": p ? "Lukk" : "Åpne",
                  className: R.actionBtn,
                  onMouseDown: (L) => L.preventDefault(),
                  onClick: () => {
                    $((L) => !L), H.current?.focus();
                  },
                  children: /* @__PURE__ */ t(
                    Fe,
                    {
                      size: 14,
                      className: `${R.chevron} ${p ? R.chevronOpen : ""}`
                    }
                  )
                }
              )
            ] })
          ] }),
          p && B.length > 0 && ct(
            /* @__PURE__ */ t(
              "ul",
              {
                ref: b,
                id: y,
                role: "listbox",
                "aria-labelledby": `${E}-label`,
                "aria-multiselectable": !!c,
                className: `${R.portalListbox} ${g === "grid" ? R.portalListboxGrid : ""}`,
                style: { top: k.top, left: k.left, width: k.width },
                children: B.map((L, V) => /* @__PURE__ */ m(
                  "li",
                  {
                    id: `${E}-option-${V}`,
                    role: "option",
                    "aria-selected": !!ce(L.value),
                    "aria-label": L.label,
                    "data-active": V === f ? !0 : void 0,
                    className: `${R.option} ${g === "grid" ? R.optionGrid : ""} ${V === f ? R.active : ""} ${ce(L.value) ? R.selected : ""}`,
                    onMouseDown: (ee) => ee.preventDefault(),
                    onClick: () => _e(L.value),
                    children: [
                      c && /* @__PURE__ */ t(
                        "span",
                        {
                          className: `${R.optionCheckbox} ${ce(L.value) ? R.optionCheckboxChecked : ""}`,
                          "aria-hidden": "true",
                          children: ce(L.value) && /* @__PURE__ */ t(Ft, { size: 10, weight: "bold", color: "white" })
                        }
                      ),
                      /* @__PURE__ */ t("span", { className: R.optionLabel, children: u ? u(L) : L.label })
                    ]
                  },
                  L.value
                ))
              }
            ),
            document.body
          ),
          p && B.length === 0 && A && /* @__PURE__ */ t("div", { className: R.empty, role: "status", children: "Ingen treff" }),
          d && /* @__PURE__ */ t("p", { id: w, className: R.error, role: "alert", children: d })
        ]
      }
    );
  }
);
nl.displayName = "Combobox";
const ll = "Checkbox-module__wrapper___Rab3a", ol = "Checkbox-module__input___UY57E", rl = "Checkbox-module__label___zy1Ey", ut = {
  wrapper: ll,
  input: ol,
  label: rl
}, bt = x(
  ({ label: n, hideLabel: a = !1, className: l, id: o, ...r }, c) => {
    const s = W(), d = o ?? s;
    return /* @__PURE__ */ m("div", { className: `${ut.wrapper} ${l ?? ""}`, children: [
      /* @__PURE__ */ t(
        "input",
        {
          ref: c,
          id: d,
          type: "checkbox",
          className: ut.input,
          ...r
        }
      ),
      /* @__PURE__ */ t("label", { htmlFor: d, className: `${ut.label} ${a ? "sr-only" : ""}`, children: n })
    ] });
  }
);
bt.displayName = "Checkbox";
const cl = "RadioGroup-module__fieldset___B3fOl", sl = "RadioGroup-module__legend___BSBF7", il = "RadioGroup-module__options___C1BxM", dl = "RadioGroup-module__option___Ms3u2", _l = "RadioGroup-module__input___IZFnD", ml = "RadioGroup-module__label___4R6wX", ye = {
  fieldset: cl,
  legend: sl,
  options: il,
  option: dl,
  input: _l,
  label: ml
}, ul = x(
  ({ legend: n, name: a, options: l, value: o, onChange: r, disabled: c, className: s, hideLabel: d = !1 }, i) => {
    const h = W();
    return /* @__PURE__ */ m(
      "fieldset",
      {
        ref: i,
        className: `${ye.fieldset} ${s ?? ""}`,
        disabled: c,
        children: [
          /* @__PURE__ */ t("legend", { className: `${ye.legend} ${d ? "sr-only" : ""}`, children: n }),
          /* @__PURE__ */ t("div", { className: ye.options, role: "radiogroup", children: l.map((_) => {
            const u = `${h}-${_.value}`;
            return /* @__PURE__ */ m("div", { className: ye.option, children: [
              /* @__PURE__ */ t(
                "input",
                {
                  id: u,
                  type: "radio",
                  name: a,
                  value: _.value,
                  checked: o === _.value,
                  disabled: _.disabled,
                  onChange: () => r?.(_.value),
                  className: ye.input
                }
              ),
              /* @__PURE__ */ t("label", { htmlFor: u, className: ye.label, children: _.label })
            ] }, _.value);
          }) })
        ]
      }
    );
  }
);
ul.displayName = "RadioGroup";
const pl = "SelectableCardGroup-module__fieldset___MNJgp", hl = "SelectableCardGroup-module__legend___qblqP", gl = "SelectableCardGroup-module__options___lHDXR", bl = "SelectableCardGroup-module__optionsRow___JwlNm", tt = {
  fieldset: pl,
  legend: hl,
  options: gl,
  optionsRow: bl
}, Qt = Ye(null);
function fl() {
  const n = qe(Qt);
  if (!n)
    throw new Error("SelectableCard må brukes inne i en <SelectableCardGroup>.");
  return n;
}
function $2(n) {
  const {
    legend: a,
    hideLegend: l = !1,
    density: o = "card",
    name: r,
    disabled: c = !1,
    className: s,
    children: d
  } = n, i = W(), h = W(), _ = r ?? i, u = n.mode, g = n.mode === "single" ? n.value : void 0, N = n.mode === "multiple" ? n.values : void 0, E = n.mode === "single" ? n.onChange : void 0, M = n.mode === "multiple" ? n.onChange : void 0, y = Nt(
    () => ({
      name: _,
      mode: u,
      density: o,
      groupDisabled: c,
      isSelected: (w) => u === "single" ? g === w : (N ?? []).includes(w),
      toggle: (w) => {
        if (u === "single")
          E?.(w);
        else {
          const H = N ?? [], b = H.includes(w) ? H.filter((v) => v !== w) : [...H, w];
          M?.(b);
        }
      }
    }),
    [_, u, o, c, g, N, E, M]
  );
  return /* @__PURE__ */ t(
    Qt.Provider,
    {
      value: y,
      children: /* @__PURE__ */ m("fieldset", { className: `${tt.fieldset} ${s ?? ""}`, disabled: c, children: [
        /* @__PURE__ */ t("legend", { id: h, className: `${tt.legend} ${l ? "sr-only" : ""}`, children: a }),
        /* @__PURE__ */ t(
          "div",
          {
            className: `${tt.options} ${o === "row" ? tt.optionsRow : ""}`,
            ...n.mode === "single" ? { role: "radiogroup", "aria-labelledby": h } : {},
            children: d
          }
        )
      ] })
    }
  );
}
const vl = "SelectableCard-module__card___qAPRl", $l = "SelectableCard-module__input___VuI7M", Al = "SelectableCard-module__content___M-54b", Nl = "SelectableCard-module__titleRow___5Ge3u", El = "SelectableCard-module__title___E7nw0", wl = "SelectableCard-module__trailing___3nsH0", Zl = "SelectableCard-module__icon___9h0bR", Ml = "SelectableCard-module__description___RNuiG", yl = "SelectableCard-module__row___MLyXy", Ll = "SelectableCard-module__selected___khT-7", Hl = "SelectableCard-module__disabled___1htuo", le = {
  card: vl,
  input: $l,
  content: Al,
  titleRow: Nl,
  title: El,
  trailing: wl,
  icon: Zl,
  description: Ml,
  row: yl,
  selected: Ll,
  disabled: Hl
};
function A2({
  value: n,
  title: a,
  description: l,
  icon: o,
  trailing: r,
  disabled: c = !1,
  className: s
}) {
  const { name: d, mode: i, density: h, groupDisabled: _, isSelected: u, toggle: g } = fl(), N = u(n), E = _ || c, M = i === "single" ? "radio" : "checkbox", y = [
    le.card,
    h === "row" ? le.row : "",
    N ? le.selected : "",
    E ? le.disabled : "",
    s ?? ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ m("label", { className: y, children: [
    /* @__PURE__ */ t(
      "input",
      {
        type: M,
        name: d,
        value: n,
        checked: N,
        disabled: E,
        onChange: () => g(n),
        className: le.input
      }
    ),
    o && /* @__PURE__ */ t("span", { className: le.icon, "aria-hidden": "true", children: o }),
    /* @__PURE__ */ m("span", { className: le.content, children: [
      /* @__PURE__ */ m("span", { className: le.titleRow, children: [
        /* @__PURE__ */ t("span", { className: le.title, children: a }),
        r && /* @__PURE__ */ t("span", { className: le.trailing, children: r })
      ] }),
      l && h !== "row" && /* @__PURE__ */ t("span", { className: le.description, children: l })
    ] })
  ] });
}
const Cl = "Switch-module__wrapper___Wq6YJ", kl = "Switch-module__labelRight___zk9Dl", Sl = "Switch-module__label___-glsZ", Il = "Switch-module__track___m8M7P", Tl = "Switch-module__checked___TsD6-", xl = "Switch-module__thumb___BdDG3", Le = {
  wrapper: Cl,
  labelRight: kl,
  label: Sl,
  track: Il,
  checked: Tl,
  thumb: xl
}, Fl = x(
  ({ label: n, checked: a = !1, onChange: l, labelPosition: o = "left", hideLabel: r = !1, className: c, id: s, ...d }, i) => {
    const h = W(), _ = s ?? h, u = `${_}-label`;
    return /* @__PURE__ */ m(
      "div",
      {
        className: `${Le.wrapper} ${o === "right" ? Le.labelRight : ""} ${c ?? ""}`,
        children: [
          /* @__PURE__ */ t("span", { id: u, className: `${Le.label} ${r ? "sr-only" : ""}`, children: n }),
          /* @__PURE__ */ t(
            "button",
            {
              ref: i,
              id: _,
              type: "button",
              role: "switch",
              "aria-checked": a,
              "aria-labelledby": u,
              onClick: () => l?.(!a),
              className: `${Le.track} ${a ? Le.checked : ""}`,
              ...d,
              children: /* @__PURE__ */ t("span", { className: Le.thumb })
            }
          )
        ]
      }
    );
  }
);
Fl.displayName = "Switch";
const Bl = "Button-module__button___NBna4", Dl = "Button-module__fullWidth___VILF3", Vl = "Button-module__primary___wgTQe", Rl = "Button-module__secondary___1OPQ8", Pl = "Button-module__danger___Bj02I", zl = "Button-module__ghost___HDitR", Ol = "Button-module__icon___5I2sM", Wl = "Button-module__sm___6dWkT", Gl = "Button-module__md___6y4KI", Ul = "Button-module__lg___Dod57", He = {
  button: Bl,
  fullWidth: Dl,
  primary: Vl,
  secondary: Rl,
  danger: Pl,
  ghost: zl,
  icon: Ol,
  sm: Wl,
  md: Gl,
  lg: Ul
}, ft = x(
  (n, a) => {
    const { variant: l = "primary", size: o = "lg", fullWidth: r, leftIcon: c, rightIcon: s, className: d, children: i } = n, h = `${He.button} ${He[l]} ${He[o]} ${r ? He.fullWidth : ""} ${d ?? ""}`, _ = /* @__PURE__ */ m(re, { children: [
      c && /* @__PURE__ */ t("span", { className: He.icon, "aria-hidden": "true", children: c }),
      i,
      s && /* @__PURE__ */ t("span", { className: He.icon, "aria-hidden": "true", children: s })
    ] });
    if (n.href !== void 0) {
      const { variant: b, size: v, fullWidth: p, leftIcon: $, rightIcon: A, children: Z, className: f, ...C } = n;
      return /* @__PURE__ */ t(
        "a",
        {
          ref: a,
          className: h,
          ...C,
          children: _
        }
      );
    }
    const { variant: u, size: g, fullWidth: N, leftIcon: E, rightIcon: M, children: y, className: w, ...H } = n;
    return /* @__PURE__ */ t(
      "button",
      {
        ref: a,
        className: h,
        ...H,
        children: _
      }
    );
  }
);
ft.displayName = "Button";
const Kl = "IconButton-module__iconButton___rcotx", Xl = "IconButton-module__outline___SHAi3", Yl = "IconButton-module__primary___AOPfb", ql = "IconButton-module__ghost___bAJCX", jl = "IconButton-module__active___yo22T", Jl = "IconButton-module__icon___0giCS", Ql = "IconButton-module__sm___BpECH", e1 = "IconButton-module__md___QdYIR", t1 = "IconButton-module__lg___--jJP", Re = {
  iconButton: Kl,
  outline: Xl,
  primary: Yl,
  ghost: ql,
  active: jl,
  icon: Jl,
  sm: Ql,
  md: e1,
  lg: t1
}, ea = x(
  ({ icon: n, label: a, size: l = "md", variant: o = "ghost", active: r = !1, type: c = "button", className: s, ...d }, i) => /* @__PURE__ */ t(
    "button",
    {
      ref: i,
      type: c,
      "aria-label": a,
      "aria-pressed": r,
      className: `${Re.iconButton} ${Re[l]} ${Re[o]} ${r ? Re.active : ""} ${s ?? ""}`,
      ...d,
      children: /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Re.icon, children: n })
    }
  )
);
ea.displayName = "IconButton";
const a1 = "SegmentedControl-module__group___xArOi", n1 = "SegmentedControl-module__full___mnNC8", l1 = "SegmentedControl-module__auto___GfhCW", o1 = "SegmentedControl-module__item___aMNsd", r1 = "SegmentedControl-module__md___pnX6X", c1 = "SegmentedControl-module__lg___JxDiU", s1 = "SegmentedControl-module__selected___cQMVK", Pe = {
  group: a1,
  full: n1,
  auto: l1,
  item: o1,
  md: r1,
  lg: c1,
  selected: s1
};
function N2({
  label: n,
  options: a,
  value: l,
  onChange: o,
  size: r = "md",
  width: c = "full",
  className: s
}) {
  const d = W(), i = S(null);
  return /* @__PURE__ */ t(
    "div",
    {
      ref: i,
      role: "radiogroup",
      "aria-label": n,
      onKeyDown: (_) => {
        if (_.key !== "ArrowLeft" && _.key !== "ArrowRight")
          return;
        _.preventDefault();
        const u = a.findIndex((M) => M.value === l), g = _.key === "ArrowRight" ? (u + 1) % a.length : (u - 1 + a.length) % a.length;
        o(a[g].value);
        const N = `${d}-${a[g].value}`;
        i.current?.querySelector(
          `#${CSS.escape(N)}`
        )?.focus();
      },
      className: `${Pe.group} ${Pe[r]} ${Pe[c]} ${s ?? ""}`,
      children: a.map((_) => {
        const u = _.value === l, g = `${d}-${_.value}`;
        return /* @__PURE__ */ t(
          "button",
          {
            id: g,
            type: "button",
            role: "radio",
            "aria-checked": u,
            tabIndex: u ? 0 : -1,
            onClick: () => o(_.value),
            className: `${Pe.item} ${u ? Pe.selected : ""}`,
            children: _.label
          },
          _.value
        );
      })
    }
  );
}
const i1 = "TabBar-module__tabBar___9j197", d1 = "TabBar-module__tab___ULbVO", _1 = "TabBar-module__tabCompact___PpF64", m1 = "TabBar-module__tabActive___ZCxrQ", u1 = "TabBar-module__tabCount___F2hQu", ze = {
  tabBar: i1,
  tab: d1,
  tabCompact: _1,
  tabActive: m1,
  tabCount: u1
};
function E2({ tabs: n, activeTab: a, onTabChange: l, size: o = "md", className: r }) {
  return /* @__PURE__ */ t(
    "div",
    {
      role: "tablist",
      className: `${ze.tabBar} ${r ?? ""}`,
      children: n.map((c) => {
        const s = c.id === a;
        return /* @__PURE__ */ m(
          "button",
          {
            role: "tab",
            type: "button",
            "aria-selected": s,
            "aria-controls": c.panelId,
            id: `tab-${c.id}`,
            className: `${ze.tab} ${o === "sm" ? ze.tabCompact : ""} ${s ? ze.tabActive : ""}`,
            onClick: () => l(c.id),
            children: [
              c.label,
              c.count !== void 0 && /* @__PURE__ */ t("span", { className: ze.tabCount, children: c.count })
            ]
          },
          c.id
        );
      })
    }
  );
}
const p1 = "Toolbar-module__toolbar___V0G3O", h1 = "Toolbar-module__vertical___C4JTT", g1 = "Toolbar-module__group___yhmD2", b1 = "Toolbar-module__groupVertical___HKCJp", f1 = "Toolbar-module__divider___D32Zh", v1 = "Toolbar-module__dividerVertical___4L-M6", xe = {
  toolbar: p1,
  vertical: h1,
  group: g1,
  groupVertical: b1,
  divider: f1,
  dividerVertical: v1
}, $1 = {
  weight: "duotone",
  color: "var(--accent-default)"
};
function w2({ children: n, id: a, className: l, "aria-label": o, orientation: r = "horizontal" }) {
  return /* @__PURE__ */ t(
    "div",
    {
      id: a,
      className: `${xe.toolbar} ${r === "vertical" ? xe.vertical : ""} ${l ?? ""}`,
      role: "toolbar",
      "aria-orientation": r,
      "aria-label": o,
      children: /* @__PURE__ */ t(Tt.Provider, { value: $1, children: n })
    }
  );
}
function Z2({ children: n, orientation: a = "horizontal" }) {
  return /* @__PURE__ */ t("div", { className: `${xe.group} ${a === "vertical" ? xe.groupVertical : ""}`, children: n });
}
function M2({ orientation: n = "horizontal" }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: `${xe.divider} ${n === "vertical" ? xe.dividerVertical : ""}`,
      role: "separator"
    }
  );
}
const A1 = "ToolbarItem-module__item___jxryp", N1 = "ToolbarItem-module__sm___Dxmlv", E1 = "ToolbarItem-module__md___rBrp9", w1 = "ToolbarItem-module__lg___tLMtl", Z1 = "ToolbarItem-module__withLabel___bOrRQ", M1 = "ToolbarItem-module__icon___MRu-m", y1 = "ToolbarItem-module__label___NxUJg", L1 = "ToolbarItem-module__active___EfGMG", Ce = {
  item: A1,
  sm: N1,
  md: E1,
  lg: w1,
  withLabel: Z1,
  icon: M1,
  label: y1,
  active: L1
}, H1 = x(
  ({ icon: n, label: a, showLabel: l = !1, size: o = "md", active: r = !1, type: c = "button", className: s, ...d }, i) => /* @__PURE__ */ m(
    "button",
    {
      ref: i,
      type: c,
      "aria-label": a,
      "aria-pressed": r,
      className: `${Ce.item} ${Ce[o]} ${l ? Ce.withLabel : ""} ${r ? Ce.active : ""} ${s ?? ""}`,
      ...d,
      children: [
        /* @__PURE__ */ t("span", { "aria-hidden": "true", className: Ce.icon, children: n }),
        l && /* @__PURE__ */ t("span", { className: Ce.label, children: a })
      ]
    }
  )
);
H1.displayName = "ToolbarItem";
const C1 = "List-module__list___-17QG", k1 = "List-module__item___pIboR", S1 = "List-module__selected___R1Q88", I1 = "List-module__disabled___rOmQW", T1 = "List-module__prefix___lpAke", x1 = "List-module__content___5yska", F1 = "List-module__label___W5T5i", B1 = "List-module__description___dUiir", D1 = "List-module__suffix___Cb0gH", de = {
  list: C1,
  item: k1,
  selected: S1,
  disabled: I1,
  prefix: T1,
  content: x1,
  label: F1,
  description: B1,
  suffix: D1
}, V1 = x(
  ({ label: n, children: a, className: l, ...o }, r) => /* @__PURE__ */ t(
    "ul",
    {
      ref: r,
      role: "list",
      "aria-label": n,
      className: `${de.list} ${l ?? ""}`,
      ...o,
      children: a
    }
  )
);
V1.displayName = "List";
const R1 = x(
  ({ children: n, description: a, prefix: l, suffix: o, selected: r, disabled: c, className: s, ...d }, i) => /* @__PURE__ */ m(
    "li",
    {
      ref: i,
      "aria-current": r ? !0 : void 0,
      "aria-disabled": c,
      className: `${de.item} ${r ? de.selected : ""} ${c ? de.disabled : ""} ${s ?? ""}`,
      ...d,
      children: [
        l && /* @__PURE__ */ t("span", { className: de.prefix, children: l }),
        /* @__PURE__ */ m("div", { className: de.content, children: [
          /* @__PURE__ */ t("span", { className: de.label, children: n }),
          a && /* @__PURE__ */ t("span", { className: de.description, children: a })
        ] }),
        o && /* @__PURE__ */ t("span", { className: de.suffix, children: o })
      ]
    }
  )
);
R1.displayName = "ListItem";
const P1 = "ListItem-module__listItem___7ikaS", z1 = "ListItem-module__interactive___7Gp-p", O1 = "ListItem-module__active___6OVUe", W1 = "ListItem-module__leading___FDU7N", G1 = "ListItem-module__content___KuDKd", U1 = "ListItem-module__trailing___jCqHd", ke = {
  listItem: P1,
  interactive: z1,
  active: O1,
  leading: W1,
  content: G1,
  trailing: U1
}, K1 = x(({ leading: n, children: a, trailing: l, onClick: o, onDoubleClick: r, active: c, className: s }, d) => {
  const i = [
    ke.listItem,
    o || r ? ke.interactive : "",
    c ? ke.active : "",
    s ?? ""
  ].filter(Boolean).join(" "), h = /* @__PURE__ */ m(re, { children: [
    n && /* @__PURE__ */ t("span", { className: ke.leading, children: n }),
    /* @__PURE__ */ t("span", { className: ke.content, children: a }),
    l && /* @__PURE__ */ t("span", { className: ke.trailing, children: l })
  ] });
  return o || r ? /* @__PURE__ */ t(
    "button",
    {
      ref: d,
      type: "button",
      className: i,
      onClick: o,
      onDoubleClick: r,
      children: h
    }
  ) : /* @__PURE__ */ t("div", { ref: d, className: i, children: h });
});
K1.displayName = "ListItem";
const X1 = "Card-module__card___QitiT", Y1 = "Card-module__header___e9Tsk", q1 = "Card-module__content___ZtA7i", j1 = "Card-module__footer___QGrH2", it = {
  card: X1,
  header: Y1,
  content: q1,
  footer: j1
}, J1 = x(
  ({ children: n, className: a, ...l }, o) => /* @__PURE__ */ t(
    "article",
    {
      ref: o,
      className: `${it.card} ${a ?? ""}`,
      ...l,
      children: n
    }
  )
);
J1.displayName = "Card";
function y2({ children: n, className: a }) {
  return /* @__PURE__ */ t("header", { className: `${it.header} ${a ?? ""}`, children: n });
}
function L2({ children: n, className: a }) {
  return /* @__PURE__ */ t("div", { className: `${it.content} ${a ?? ""}`, children: n });
}
function H2({ children: n, className: a }) {
  return /* @__PURE__ */ t("footer", { className: `${it.footer} ${a ?? ""}`, children: n });
}
const Q1 = "ListCard-module__card___QPe8e", eo = "ListCard-module__prefix___bx-8s", to = "ListCard-module__body___7BKHb", ao = "ListCard-module__bodyAlignStart___lRIIP", no = "ListCard-module__content___BcWzS", lo = "ListCard-module__title___jActg", oo = "ListCard-module__titleMonospace___8-yGu", ro = "ListCard-module__description___ZINkM", co = "ListCard-module__action___3clMo", so = "ListCard-module__titleButton___3IDrw", io = "ListCard-module__clickable___JzT-y", _o = "ListCard-module__selected___KiDyI", ae = {
  card: Q1,
  prefix: eo,
  body: to,
  bodyAlignStart: ao,
  content: no,
  title: lo,
  titleMonospace: oo,
  description: ro,
  action: co,
  titleButton: so,
  clickable: io,
  selected: _o
};
function C2({ title: n, titleMonospace: a, description: l, prefix: o, prefixAlign: r = "center", action: c, className: s, selected: d, onClick: i, onMouseEnter: h, onMouseLeave: _ }) {
  const u = `${ae.title} ${a ? ae.titleMonospace : ""}`, g = i ? /* @__PURE__ */ t("button", { type: "button", className: ae.titleButton, onClick: i, children: /* @__PURE__ */ t("span", { className: u, children: n }) }) : /* @__PURE__ */ t("span", { className: u, children: n }), N = /* @__PURE__ */ m("div", { className: ae.content, children: [
    g,
    l && /* @__PURE__ */ t("span", { className: ae.description, children: l })
  ] });
  return /* @__PURE__ */ m(
    "article",
    {
      className: `${ae.card} ${i ? ae.clickable : ""} ${d ? ae.selected : ""} ${s ?? ""}`,
      onMouseEnter: h,
      onMouseLeave: _,
      children: [
        o ? /* @__PURE__ */ m("div", { className: `${ae.body} ${r === "start" ? ae.bodyAlignStart : ""}`, children: [
          /* @__PURE__ */ t("div", { className: ae.prefix, children: o }),
          N
        ] }) : N,
        c && /* @__PURE__ */ t("div", { className: ae.action, children: c })
      ]
    }
  );
}
const mo = "SearchResultCard-module__card___-Gka3", uo = "SearchResultCard-module__stretchedButton___ac2HD", po = "SearchResultCard-module__focused___mgOpO", ho = "SearchResultCard-module__content___l9043", go = "SearchResultCard-module__title___-jEqv", bo = "SearchResultCard-module__meta___dMKES", fo = "SearchResultCard-module__subtitle___nifkp", vo = "SearchResultCard-module__status___YVonv", $o = "SearchResultCard-module__secondaryAction___mNoGn", se = {
  card: mo,
  stretchedButton: uo,
  focused: po,
  content: ho,
  title: go,
  meta: bo,
  subtitle: fo,
  status: vo,
  secondaryAction: $o
}, Ao = x(
  ({
    title: n,
    subtitle: a,
    status: l,
    secondaryAction: o,
    onClick: r,
    onMouseEnter: c,
    onMouseLeave: s,
    onFocus: d,
    onBlur: i,
    isFocused: h,
    className: _
  }, u) => {
    const g = !!l || !!a;
    return /* @__PURE__ */ m(
      "article",
      {
        ref: u,
        className: [se.card, h ? se.focused : "", _ ?? ""].filter(Boolean).join(" "),
        onMouseEnter: c,
        onMouseLeave: s,
        children: [
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: se.stretchedButton,
              onClick: r,
              onFocus: d,
              onBlur: i,
              "aria-label": n
            }
          ),
          /* @__PURE__ */ m("div", { className: se.content, children: [
            /* @__PURE__ */ t("span", { className: se.title, children: n }),
            g && /* @__PURE__ */ m("div", { className: se.meta, children: [
              l && /* @__PURE__ */ t("div", { className: se.status, children: l }),
              a && /* @__PURE__ */ t("span", { className: se.subtitle, children: a })
            ] })
          ] }),
          o && /* @__PURE__ */ t("div", { className: se.secondaryAction, children: o })
        ]
      }
    );
  }
);
Ao.displayName = "SearchResultCard";
const No = "Chip-module__chip___uxY-c", Eo = "Chip-module__info___gt8SM", wo = "Chip-module__success___5-5sd", Zo = "Chip-module__warning___F19BQ", Mo = "Chip-module__danger___-Gjoy", yo = "Chip-module__onbrand___tvCkD", Lo = "Chip-module__icon___Z-eSE", Ho = "Chip-module__label___JFLFr", Co = "Chip-module__remove___ZkCbH", Oe = {
  chip: No,
  default: "Chip-module__default___Dinv4",
  info: Eo,
  success: wo,
  warning: Zo,
  danger: Mo,
  onbrand: yo,
  icon: Lo,
  label: Ho,
  remove: Co
}, ko = x(
  ({
    children: n,
    variant: a = "default",
    icon: l,
    onRemove: o,
    removeLabel: r = "Fjern",
    className: c,
    ...s
  }, d) => /* @__PURE__ */ m(
    "span",
    {
      ref: d,
      className: `${Oe.chip} ${Oe[a]} ${c ?? ""}`,
      ...s,
      children: [
        l && /* @__PURE__ */ t("span", { className: Oe.icon, "aria-hidden": "true", children: l }),
        /* @__PURE__ */ t("span", { className: Oe.label, children: n }),
        o && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            "aria-label": `${r} ${typeof n == "string" ? n : ""}`,
            onClick: o,
            className: Oe.remove,
            children: /* @__PURE__ */ t(ne, { size: 12, weight: "bold" })
          }
        )
      ]
    }
  )
);
ko.displayName = "Chip";
const So = "FilterChipGroup-module__filterRow___mmL6n", Io = "FilterChipGroup-module__filterChip___QngEB", To = "FilterChipGroup-module__filterChipActive___gFTcz", xo = "FilterChipGroup-module__filterChipCount___PPTC-", at = {
  filterRow: So,
  filterChip: Io,
  filterChipActive: To,
  filterChipCount: xo
}, Fo = x(
  ({ label: n, options: a, value: l, onChange: o, className: r }, c) => /* @__PURE__ */ t(
    "div",
    {
      ref: c,
      role: "radiogroup",
      "aria-label": n,
      className: `${at.filterRow} ${r ?? ""}`,
      children: a.map((s) => {
        const d = s.value === l;
        return /* @__PURE__ */ m(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": d,
            className: `${at.filterChip} ${d ? at.filterChipActive : ""}`,
            onClick: () => o(s.value),
            children: [
              s.label,
              s.count !== void 0 && /* @__PURE__ */ t("span", { className: at.filterChipCount, "aria-hidden": "true", children: s.count })
            ]
          },
          s.value
        );
      })
    }
  )
);
Fo.displayName = "FilterChipGroup";
const Bo = "Avatar-module__avatar___G2xrz", Do = "Avatar-module__sm___HCOUV", Vo = "Avatar-module__md___dHepW", Ro = "Avatar-module__lg___ouZDr", Po = "Avatar-module__image___UMWuG", zo = "Avatar-module__initials___cPOmk", nt = {
  avatar: Bo,
  sm: Do,
  md: Vo,
  lg: Ro,
  image: Po,
  initials: zo
}, Oo = { sm: 28, md: 36, lg: 48 };
function Wo({ src: n, alt: a, initials: l, size: o = "md", className: r }) {
  const c = Oo[o];
  return /* @__PURE__ */ t(
    "span",
    {
      className: `${nt.avatar} ${nt[o]} ${r ?? ""}`,
      role: "img",
      "aria-label": a,
      children: n ? /* @__PURE__ */ t("img", { src: n, alt: "", width: c, height: c, className: nt.image }) : /* @__PURE__ */ t("span", { className: nt.initials, "aria-hidden": "true", children: l ?? a.charAt(0).toUpperCase() })
    }
  );
}
const Go = "StatusDot-module__dot___WknV2", Uo = "StatusDot-module__sm___t8o2u", Ko = "StatusDot-module__md___aJwIq", Xo = "StatusDot-module__error___lyt1X", Yo = "StatusDot-module__warning___P2rsU", qo = "StatusDot-module__success___VWkra", jo = "StatusDot-module__info___jNXYJ", pt = {
  dot: Go,
  sm: Uo,
  md: Ko,
  error: Xo,
  warning: Yo,
  success: qo,
  info: jo
};
function k2({
  variant: n,
  label: a,
  size: l = "sm",
  children: o,
  className: r
}) {
  return /* @__PURE__ */ t(
    "span",
    {
      className: `${pt.dot} ${pt[l]} ${pt[n]} ${r ?? ""}`,
      role: a ? "img" : void 0,
      "aria-label": a,
      children: l === "md" ? o : null
    }
  );
}
const Jo = "Table-module__scroll___5RcC3", Qo = "Table-module__table___Zk0Qo", er = "Table-module__layoutFixed___-em-r", tr = "Table-module__head___KWk3X", ar = "Table-module__th___U8BvP", nr = "Table-module__sortButton___GyPcH", lr = "Table-module__sortIcon___ITFh1", or = "Table-module__sortIconIdle___vYObA", rr = "Table-module__row___eDxYw", cr = "Table-module__striped___kTqGn", sr = "Table-module__selected___H0JPu", ir = "Table-module__interactive___8znT8", dr = "Table-module__alignLeft___DoJnb", _r = "Table-module__alignRight___u1OFt", mr = "Table-module__alignCenter___fblc3", j = {
  scroll: Jo,
  table: Qo,
  layoutFixed: er,
  head: tr,
  th: ar,
  sortButton: nr,
  sortIcon: lr,
  sortIconIdle: or,
  row: rr,
  striped: cr,
  selected: sr,
  interactive: ir,
  alignLeft: dr,
  alignRight: _r,
  alignCenter: mr
}, ta = {
  left: j.alignLeft,
  right: j.alignRight,
  center: j.alignCenter
}, aa = x(
  ({ children: n, label: a, layout: l = "auto", className: o, ...r }, c) => /* @__PURE__ */ t("div", { className: j.scroll, children: /* @__PURE__ */ t(
    "table",
    {
      ref: c,
      className: [j.table, l === "fixed" ? j.layoutFixed : "", o ?? ""].filter(Boolean).join(" "),
      "aria-label": a,
      ...r,
      children: n
    }
  ) })
);
aa.displayName = "Table";
const na = x(
  ({ children: n, className: a, ...l }, o) => /* @__PURE__ */ t("thead", { ref: o, className: `${j.head} ${a ?? ""}`, ...l, children: n })
);
na.displayName = "TableHead";
const la = x(
  ({ children: n, className: a, ...l }, o) => /* @__PURE__ */ t("tbody", { ref: o, className: a, ...l, children: n })
);
la.displayName = "TableBody";
const rt = x(
  ({ children: n, selected: a, striped: l, className: o, onClick: r, ...c }, s) => {
    const d = [
      j.row,
      r ? j.interactive : "",
      l ? j.striped : "",
      a ? j.selected : "",
      o ?? ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t(
      "tr",
      {
        ref: s,
        className: d,
        onClick: r,
        "aria-selected": a || void 0,
        ...c,
        children: n
      }
    );
  }
);
rt.displayName = "TableRow";
const vt = x(
  ({ children: n, align: a = "left", sortable: l, sortDirection: o, onSort: r, hideLabel: c, className: s, ...d }, i) => /* @__PURE__ */ t(
    "th",
    {
      ref: i,
      scope: "col",
      "aria-sort": l ? o === "asc" ? "ascending" : o === "desc" ? "descending" : "none" : void 0,
      className: `${j.th} ${ta[a]} ${s ?? ""}`,
      ...d,
      children: l ? /* @__PURE__ */ m("button", { type: "button", className: j.sortButton, onClick: r, children: [
        /* @__PURE__ */ t("span", { className: c ? "sr-only" : void 0, children: n }),
        /* @__PURE__ */ t("span", { className: j.sortIcon, "aria-hidden": "true", children: o === "asc" ? /* @__PURE__ */ t(Oa, { size: 12, weight: "bold" }) : o === "desc" ? /* @__PURE__ */ t(Ht, { size: 12, weight: "bold" }) : /* @__PURE__ */ t(Ht, { size: 12, className: j.sortIconIdle }) })
      ] }) : /* @__PURE__ */ t("span", { className: c ? "sr-only" : void 0, children: n })
    }
  )
);
vt.displayName = "TableHeaderCell";
const Ke = x(
  ({ children: n, align: a = "left", header: l, className: o, ...r }, c) => {
    const s = `${ta[a]} ${o ?? ""}`;
    return l ? /* @__PURE__ */ t("th", { ref: c, scope: "row", className: s, ...r, children: n }) : /* @__PURE__ */ t("td", { ref: c, className: s, ...r, children: n });
  }
);
Ke.displayName = "TableCell";
const ur = "Pagination-module__pagination___mvmcB", pr = "Pagination-module__button___1sndM", hr = "Pagination-module__active___AA8o-", We = {
  pagination: ur,
  button: pr,
  active: hr
};
function gr({
  currentPage: n,
  totalPages: a,
  onPageChange: l,
  className: o
}) {
  const r = Array.from({ length: a }, (c, s) => s + 1);
  return /* @__PURE__ */ m("nav", { "aria-label": "Paginering", className: `${We.pagination} ${o ?? ""}`, children: [
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        disabled: n <= 1,
        "aria-label": "Forrige side",
        onClick: () => l(n - 1),
        className: We.button,
        children: "‹"
      }
    ),
    r.map((c) => /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "aria-label": `Side ${c}`,
        "aria-current": c === n ? "page" : void 0,
        onClick: () => l(c),
        className: `${We.button} ${c === n ? We.active : ""}`,
        children: c
      },
      c
    )),
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        disabled: n >= a,
        "aria-label": "Neste side",
        onClick: () => l(n + 1),
        className: We.button,
        children: "›"
      }
    )
  ] });
}
const br = "EmptyState-module__root___m61Zc", fr = "EmptyState-module__header___Lz8r9", vr = "EmptyState-module__icon___dbe9o", $r = "EmptyState-module__text___C9ab9", Ar = "EmptyState-module__title___yiN9U", Nr = "EmptyState-module__description___k0geC", Er = "EmptyState-module__action___0jspg", $e = {
  root: br,
  header: fr,
  icon: vr,
  text: $r,
  title: Ar,
  description: Nr,
  action: Er
}, oa = x(
  ({ title: n, description: a, icon: l, action: o, className: r }, c) => /* @__PURE__ */ m("div", { ref: c, className: `${$e.root} ${r ?? ""}`, children: [
    /* @__PURE__ */ m("div", { className: $e.header, children: [
      l && /* @__PURE__ */ t("span", { className: $e.icon, "aria-hidden": "true", children: l }),
      /* @__PURE__ */ m("div", { className: $e.text, children: [
        /* @__PURE__ */ t("p", { className: $e.title, children: n }),
        a && /* @__PURE__ */ t("p", { className: $e.description, children: a })
      ] })
    ] }),
    o && /* @__PURE__ */ t("div", { className: $e.action, children: o })
  ] })
);
oa.displayName = "EmptyState";
const wr = "DataTable-module__wrapper___mCPSn", Zr = "DataTable-module__bulkSlot___fNRw-", Mr = "DataTable-module__bulkOpen___n5p5x", yr = "DataTable-module__bulkInner___6trtX", Lr = "DataTable-module__bulkBar___P8J-4", Hr = "DataTable-module__bulkSummary___VLt2g", Cr = "DataTable-module__bulkActions___U86kV", kr = "DataTable-module__tableCard___zeJZ2", Sr = "DataTable-module__rowTrigger___CGq74", Ir = "DataTable-module__cellStack___2BHUm", Tr = "DataTable-module__cellSubtitle___FYOgl", xr = "DataTable-module__cellTitle___ReSoA", Fr = "DataTable-module__emptyWrap___nmUBw", Br = "DataTable-module__skelBar___epSo8", Dr = "DataTable-module__skelPulse___ZTFM6", Vr = "DataTable-module__skelBox___S3EsO", Rr = "DataTable-module__footer___NGdVW", Pr = "DataTable-module__pageSummary___QoTWO", X = {
  wrapper: wr,
  bulkSlot: Zr,
  bulkOpen: Mr,
  bulkInner: yr,
  bulkBar: Lr,
  bulkSummary: Hr,
  bulkActions: Cr,
  tableCard: kr,
  rowTrigger: Sr,
  cellStack: Ir,
  cellSubtitle: Tr,
  cellTitle: xr,
  emptyWrap: Fr,
  skelBar: Br,
  skelPulse: Dr,
  skelBox: Vr,
  footer: Rr,
  pageSummary: Pr
}, Ct = ["62%", "44%", "72%", "38%", "55%"], ra = 40, ht = {
  width: ra,
  paddingLeft: "var(--space-03)",
  paddingRight: 0
};
function S2({
  columns: n,
  data: a,
  getRowId: l = (p) => p.id,
  selectable: o,
  selectedIds: r = [],
  onSelectionChange: c,
  rowSelectLabel: s,
  sort: d,
  onSortChange: i,
  onRowClick: h,
  rowClickLabel: _,
  rowClickArea: u = "name",
  bulkActions: g,
  bulkSummary: N,
  pagination: E,
  zebra: M,
  loading: y,
  loadingRows: w = 5,
  emptyMessage: H = "Ingen rader å vise.",
  emptyState: b,
  label: v
}) {
  const p = new Set(r), $ = a.map(l), A = a.length > 0 && $.every((I) => p.has(I)), Z = $.some((I) => p.has(I)) && !A, f = S(null);
  U(() => {
    f.current && (f.current.indeterminate = Z);
  }, [Z]);
  const C = S(null), [k, G] = F(Number.POSITIVE_INFINITY);
  U(() => {
    const I = C.current;
    if (!I || typeof ResizeObserver > "u")
      return;
    const L = new ResizeObserver((V) => {
      const ee = V[0]?.contentRect.width;
      ee && G(ee);
    });
    return L.observe(I), () => L.disconnect();
  }, []);
  const B = n.filter((I) => !I.hideBelow || k >= I.hideBelow), ce = () => {
    if (c)
      if (A) {
        const I = new Set($);
        c(r.filter((L) => !I.has(L)));
      } else
        c([.../* @__PURE__ */ new Set([...r, ...$])]);
  }, _e = (I) => {
    c && c(
      p.has(I) ? r.filter((L) => L !== I) : [...r, I]
    );
  }, Be = (I) => {
    if (!I.sortable || !i)
      return;
    const L = d?.columnId === I.id && d.direction === "asc" ? "desc" : "asc";
    i({ columnId: I.id, direction: L });
  }, K = (I) => (L) => {
    h && (L.target.closest("input, button, a, label") || h(I));
  }, we = 200, je = (o ? ra : 0) + B.reduce(
    (I, L) => I + (parseInt(L.width ?? "", 10) || we),
    0
  );
  return /* @__PURE__ */ m("div", { className: X.wrapper, ref: C, children: [
    /* @__PURE__ */ t("span", { className: "sr-only", role: "status", "aria-live": "polite", children: y ? "Laster …" : "" }),
    o && (g || N) && /* @__PURE__ */ t(
      "div",
      {
        className: `${X.bulkSlot} ${r.length > 0 ? X.bulkOpen : ""}`,
        children: /* @__PURE__ */ t("div", { className: X.bulkInner, children: /* @__PURE__ */ m(
          "div",
          {
            className: X.bulkBar,
            role: "region",
            "aria-label": "Valgte rader",
            "aria-hidden": r.length === 0 || void 0,
            children: [
              /* @__PURE__ */ t("span", { className: X.bulkSummary, children: N ? N(r.length) : `${r.length} valgt` }),
              g && /* @__PURE__ */ t("div", { className: X.bulkActions, children: g })
            ]
          }
        ) })
      }
    ),
    /* @__PURE__ */ t("div", { className: X.tableCard, children: !y && a.length === 0 ? /* @__PURE__ */ t("div", { className: X.emptyWrap, children: b ?? /* @__PURE__ */ t(oa, { title: H }) }) : /* @__PURE__ */ m(aa, { label: v, layout: "fixed", "aria-busy": y || void 0, style: { minWidth: `${je}px` }, children: [
      /* @__PURE__ */ t(na, { children: /* @__PURE__ */ m(rt, { children: [
        o && /* @__PURE__ */ t(vt, { style: ht, children: /* @__PURE__ */ t(
          bt,
          {
            ref: f,
            label: "Velg alle rader",
            hideLabel: !0,
            checked: A,
            onChange: ce,
            disabled: y
          }
        ) }),
        B.map((I) => /* @__PURE__ */ t(
          vt,
          {
            align: I.align,
            sortable: I.sortable,
            sortDirection: d?.columnId === I.id ? d.direction : null,
            onSort: () => Be(I),
            style: I.width ? { width: I.width } : void 0,
            children: I.header
          },
          I.id
        ))
      ] }) }),
      /* @__PURE__ */ t(la, { children: y ? Array.from({ length: w }).map((I, L) => /* @__PURE__ */ m(rt, { children: [
        o && /* @__PURE__ */ t(Ke, { style: ht, children: /* @__PURE__ */ t("span", { className: X.skelBox, "aria-hidden": "true" }) }),
        B.map((V, ee) => /* @__PURE__ */ t(Ke, { align: V.align, children: /* @__PURE__ */ t(
          "span",
          {
            className: X.skelBar,
            "aria-hidden": "true",
            style: { width: Ct[ee % Ct.length] }
          }
        ) }, V.id))
      ] }, `skeleton-${L}`)) : a.map((I, L) => {
        const V = l(I), ee = p.has(V);
        return /* @__PURE__ */ m(
          rt,
          {
            selected: ee,
            striped: M ? L % 2 === 1 : void 0,
            onClick: h && u === "row" ? K(I) : void 0,
            children: [
              o && /* @__PURE__ */ t(Ke, { style: ht, children: /* @__PURE__ */ t(
                bt,
                {
                  label: s ? s(I) : "Velg rad",
                  hideLabel: !0,
                  checked: ee,
                  onChange: () => _e(V)
                }
              ) }),
              B.map((me, De) => {
                const Lt = me.render(I), Je = me.subtitle?.(I), dt = Je != null && typeof Je != "boolean" && Je !== "", _t = dt ? /* @__PURE__ */ m(re, { children: [
                  /* @__PURE__ */ t("span", { className: X.cellTitle, children: Lt }),
                  /* @__PURE__ */ t("span", { className: X.cellSubtitle, children: Je })
                ] }) : Lt;
                let mt = _t;
                return h && De === 0 ? mt = /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: [X.rowTrigger, dt && X.cellStack].filter(Boolean).join(" "),
                    onClick: () => h(I),
                    "aria-label": _ ? _(I) : void 0,
                    children: _t
                  }
                ) : dt && (mt = /* @__PURE__ */ t("span", { className: X.cellStack, children: _t })), /* @__PURE__ */ t(Ke, { align: me.align, children: mt }, me.id);
              })
            ]
          },
          V
        );
      }) })
    ] }) }),
    E && E.totalPages > 1 && /* @__PURE__ */ m("div", { className: X.footer, children: [
      E.summary && /* @__PURE__ */ t("span", { className: X.pageSummary, children: E.summary }),
      /* @__PURE__ */ t(
        gr,
        {
          currentPage: E.currentPage,
          totalPages: E.totalPages,
          onPageChange: E.onPageChange
        }
      )
    ] })
  ] });
}
const zr = "Banner-module__banner___mwAl3", Or = "Banner-module__info___K-ioh", Wr = "Banner-module__warning___sUmXq", Gr = "Banner-module__error___I3HKu", Ur = "Banner-module__success___sVsk0", Kr = "Banner-module__dot___oFIkJ", Xr = "Banner-module__icon___6kX-F", Yr = "Banner-module__text___vNAsI", qr = "Banner-module__action___OcfUK", Se = {
  banner: zr,
  info: Or,
  warning: Wr,
  error: Gr,
  success: Ur,
  dot: Kr,
  icon: Xr,
  text: Yr,
  action: qr
}, jr = x(
  ({ variant: n = "info", icon: a, children: l, action: o, className: r, ...c }, s) => /* @__PURE__ */ m(
    "div",
    {
      ref: s,
      role: "status",
      "data-variant": n,
      className: `${Se.banner} ${Se[n]} ${r ?? ""}`,
      ...c,
      children: [
        a ? /* @__PURE__ */ t("span", { className: Se.icon, "aria-hidden": "true", children: a }) : /* @__PURE__ */ t("span", { className: Se.dot, "aria-hidden": "true" }),
        /* @__PURE__ */ t("div", { className: Se.text, children: l }),
        o && /* @__PURE__ */ t("div", { className: Se.action, children: o })
      ]
    }
  )
);
jr.displayName = "Banner";
const Jr = "Notice-module__notice___N-bMe", Qr = "Notice-module__info___TVAG7", ec = "Notice-module__success___qWYJf", tc = "Notice-module__warning___kIS9g", ac = "Notice-module__danger___YeKcT", nc = "Notice-module__icon___COjtB", lc = "Notice-module__content___tdQXe", oc = "Notice-module__dismiss___0PwGQ", Ge = {
  notice: Jr,
  info: Qr,
  success: ec,
  warning: tc,
  danger: ac,
  icon: nc,
  content: lc,
  dismiss: oc
}, rc = x(
  ({ variant: n = "info", icon: a, children: l, onDismiss: o, className: r, ...c }, s) => /* @__PURE__ */ m(
    "div",
    {
      ref: s,
      role: "status",
      className: `${Ge.notice} ${Ge[n]} ${r ?? ""}`,
      ...c,
      children: [
        a && /* @__PURE__ */ t("span", { className: Ge.icon, "aria-hidden": "true", children: a }),
        /* @__PURE__ */ t("div", { className: Ge.content, children: l }),
        o && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            "aria-label": "Lukk",
            onClick: o,
            className: Ge.dismiss,
            children: /* @__PURE__ */ t(ne, { size: 16, weight: "bold" })
          }
        )
      ]
    }
  )
);
rc.displayName = "Notice";
const cc = "Alert-module__alert___IRmbI", sc = "Alert-module__info___yeWWq", ic = "Alert-module__success___WxkA1", dc = "Alert-module__warning___E2ixX", _c = "Alert-module__danger___aMtI-", mc = "Alert-module__icon___xqd0Z", uc = "Alert-module__content___dKCR5", pc = "Alert-module__close___fPz3E", Ue = {
  alert: cc,
  info: sc,
  success: ic,
  warning: dc,
  danger: _c,
  icon: mc,
  content: uc,
  close: pc
};
function I2({
  variant: n = "info",
  icon: a,
  children: l,
  open: o,
  onClose: r,
  autoCloseDuration: c,
  className: s
}) {
  const [d, i] = F(o);
  return U(() => {
    i(o);
  }, [o]), U(() => {
    if (d && c) {
      const h = setTimeout(() => {
        i(!1), r?.();
      }, c);
      return () => clearTimeout(h);
    }
  }, [d, c, r]), d ? /* @__PURE__ */ m(
    "div",
    {
      role: "alert",
      "aria-live": "assertive",
      className: `${Ue.alert} ${Ue[n]} ${s ?? ""}`,
      children: [
        a && /* @__PURE__ */ t("span", { className: Ue.icon, "aria-hidden": "true", children: a }),
        /* @__PURE__ */ t("div", { className: Ue.content, children: l }),
        r && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            "aria-label": "Lukk",
            onClick: () => {
              i(!1), r();
            },
            className: Ue.close,
            children: /* @__PURE__ */ t(ne, { size: 16, weight: "bold" })
          }
        )
      ]
    }
  ) : null;
}
const hc = "Loader-module__loader___kwWmf", gc = "Loader-module__spinner___dgodN", bc = "Loader-module__spin___ikVcT", fc = "Loader-module__inline___TvzTG", vc = "Loader-module__sm___-QLZb", $c = "Loader-module__md___4ukEW", Ac = "Loader-module__lg___j4VPE", Nc = "Loader-module__xl___FSZyk", lt = {
  loader: hc,
  spinner: gc,
  spin: bc,
  inline: fc,
  sm: vc,
  md: $c,
  lg: Ac,
  xl: Nc
};
function T2({
  label: n = "Laster…",
  size: a = "md",
  inline: l = !1,
  className: o
}) {
  return /* @__PURE__ */ m(
    "span",
    {
      role: "status",
      "aria-label": n,
      className: `${lt.loader} ${lt[a]} ${l ? lt.inline : ""} ${o ?? ""}`,
      children: [
        /* @__PURE__ */ t("span", { className: lt.spinner, "aria-hidden": "true" }),
        /* @__PURE__ */ t("span", { className: "sr-only", children: n })
      ]
    }
  );
}
const Ec = "Toast-module__viewport___zkDgN", wc = "Toast-module__toast___xO6y2", Zc = "Toast-module__toast-enter___1ELXo", Mc = "Toast-module__toast-enter-top___fXmpw", yc = "Toast-module__leaving___CjxVt", Lc = "Toast-module__toast-exit___vVw-K", Hc = "Toast-module__info___-8Ukt", Cc = "Toast-module__success___uJtOh", kc = "Toast-module__warning___lkNzP", Sc = "Toast-module__danger___h88Zz", Ic = "Toast-module__icon___3PmeW", Tc = "Toast-module__message___eXbuN", xc = "Toast-module__action___s3zIH", Fc = "Toast-module__dismiss___X-6Gm", ue = {
  viewport: Ec,
  toast: wc,
  toastEnter: Zc,
  toastEnterTop: Mc,
  leaving: yc,
  toastExit: Lc,
  info: Hc,
  success: Cc,
  warning: kc,
  danger: Sc,
  icon: Ic,
  message: Tc,
  action: xc,
  dismiss: Fc
}, $t = Ye(null);
function x2() {
  const n = qe($t);
  if (!n)
    throw new Error("useToast må brukes innenfor en <ToastProvider>.");
  return n;
}
const Bc = 5e3;
function Dc() {
  if (typeof window > "u")
    return 350;
  const n = getComputedStyle(document.documentElement).getPropertyValue("--duration-base").trim(), a = parseFloat(n);
  return Number.isNaN(a) ? 350 : (n.endsWith("ms") ? a : a * 1e3) + 150;
}
const Vc = {
  info: /* @__PURE__ */ t(Pt, { size: 20, weight: "fill" }),
  success: /* @__PURE__ */ t(Bt, { size: 20, weight: "fill" }),
  warning: /* @__PURE__ */ t(jt, { size: 20, weight: "fill" }),
  danger: /* @__PURE__ */ t(Jt, { size: 20, weight: "fill" })
};
function Rc({
  children: n,
  position: a = "bottom-center",
  max: l = 4
}) {
  const [o, r] = F([]), c = S(/* @__PURE__ */ new Map()), s = S(/* @__PURE__ */ new Map()), d = S(0), i = S(0), [h, _] = F(!1), u = (b) => {
    const v = c.current.get(b);
    v?.timeoutId != null && window.clearTimeout(v.timeoutId), c.current.delete(b);
  };
  U(() => (_(!0), () => {
    c.current.forEach((b) => {
      b.timeoutId != null && window.clearTimeout(b.timeoutId);
    }), c.current.clear(), s.current.forEach((b) => window.clearTimeout(b)), s.current.clear();
  }), []);
  const g = T((b) => {
    r((p) => p.filter(($) => $.id !== b));
    const v = s.current.get(b);
    v && (window.clearTimeout(v), s.current.delete(b)), c.current.delete(b);
  }, []), N = T(
    (b) => {
      u(b), r((v) => v.map((p) => p.id === b ? { ...p, leaving: !0 } : p)), s.current.has(b) || s.current.set(b, window.setTimeout(() => g(b), Dc()));
    },
    [g]
  ), E = T(
    (b) => {
      const v = c.current.get(b);
      !v || v.timeoutId != null || (v.startedAt = Date.now(), v.timeoutId = window.setTimeout(() => N(b), v.remaining));
    },
    [N]
  ), M = T(
    (b, v = {}) => {
      const p = `toast-${i.current += 1}`, $ = v.variant ?? "info", A = v.duration === void 0 ? Bc : v.duration, Z = A != null && A > 0 ? A : null;
      return r((f) => {
        const C = [...f, { id: p, message: b, variant: $, duration: Z, action: v.action, leaving: !1 }];
        if (C.length > l) {
          for (const k of C.slice(0, C.length - l)) {
            u(k.id);
            const G = s.current.get(k.id);
            G && (window.clearTimeout(G), s.current.delete(k.id));
          }
          return C.slice(-l);
        }
        return C;
      }), Z != null && (c.current.set(p, { timeoutId: null, remaining: Z, startedAt: null }), d.current === 0 && E(p)), p;
    },
    [l, E]
  ), y = T(() => {
    if (d.current += 1, d.current === 1)
      for (const b of c.current.values())
        b.timeoutId != null && (window.clearTimeout(b.timeoutId), b.startedAt != null && (b.remaining = Math.max(0, b.remaining - (Date.now() - b.startedAt))), b.timeoutId = null, b.startedAt = null);
  }, []), w = T(() => {
    if (d.current = Math.max(0, d.current - 1), d.current === 0)
      for (const [b, v] of [...c.current])
        v.timeoutId == null && (v.remaining <= 0 ? N(b) : E(b));
  }, [E, N]), H = Nt(() => {
    const b = (v) => (p, $ = {}) => M(p, { ...$, variant: v });
    return {
      show: M,
      info: b("info"),
      success: b("success"),
      warning: b("warning"),
      danger: b("danger"),
      dismiss: N
    };
  }, [M, N]);
  return h ? /* @__PURE__ */ m($t.Provider, { value: H, children: [
    n,
    ct(
      /* @__PURE__ */ t(
        "ol",
        {
          className: ue.viewport,
          "data-position": a,
          "aria-label": "Varsler",
          "aria-live": "polite",
          "aria-atomic": "false",
          onMouseEnter: y,
          onMouseLeave: w,
          onFocusCapture: y,
          onBlurCapture: w,
          children: o.map((b) => /* @__PURE__ */ m(
            "li",
            {
              className: `${ue.toast} ${ue[b.variant]} ${b.leaving ? ue.leaving : ""}`,
              role: b.variant === "danger" ? "alert" : void 0,
              onAnimationEnd: (v) => {
                v.target === v.currentTarget && b.leaving && g(b.id);
              },
              children: [
                /* @__PURE__ */ t("span", { className: ue.icon, "aria-hidden": "true", children: Vc[b.variant] }),
                /* @__PURE__ */ t("div", { className: ue.message, children: b.message }),
                b.action && /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: ue.action,
                    onClick: () => {
                      b.action.onClick(), N(b.id);
                    },
                    children: b.action.label
                  }
                ),
                /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: ue.dismiss,
                    "aria-label": "Lukk",
                    onClick: (v) => {
                      const p = v.currentTarget.closest("li"), $ = p?.nextElementSibling ?? p?.previousElementSibling;
                      N(b.id), $?.querySelector("button")?.focus();
                    },
                    children: /* @__PURE__ */ t(ne, { size: 16, weight: "bold" })
                  }
                )
              ]
            },
            b.id
          ))
        }
      ),
      document.body
    )
  ] }) : /* @__PURE__ */ t($t.Provider, { value: H, children: n });
}
Rc.displayName = "ToastProvider";
const Pc = "Dialog-module__dialog___4QI6F", zc = "Dialog-module__dialog-enter___bC1FT", Oc = "Dialog-module__backdrop-enter___Iu6ai", Wc = "Dialog-module__container___Enlam", Gc = "Dialog-module__header___4XcDg", Uc = "Dialog-module__title___adFHq", Kc = "Dialog-module__close___hym5n", Xc = "Dialog-module__content___SosUd", Yc = "Dialog-module__footer___K2lCC", Ae = {
  dialog: Pc,
  dialogEnter: zc,
  backdropEnter: Oc,
  container: Wc,
  header: Gc,
  title: Uc,
  close: Kc,
  content: Xc,
  footer: Yc
};
function kt(n) {
  return n instanceof HTMLInputElement && n.type === "file";
}
function qc({ open: n, onClose: a, title: l, children: o, footer: r, className: c, returnFocusRef: s }) {
  const d = S(null), i = S(null), h = S(!1), _ = W(), u = S(null), [g, N] = F(!1);
  U(() => {
    if (!n)
      return;
    const w = u.current;
    if (!w)
      return;
    const H = () => N(w.scrollHeight > w.clientHeight);
    H();
    const b = new ResizeObserver(H);
    return b.observe(w), () => b.disconnect();
  }, [n]), U(() => {
    const w = d.current;
    if (w) {
      if (n && !w.open)
        i.current = document.activeElement, w.showModal();
      else if (!n && w.open) {
        w.close();
        const H = s?.current ?? i.current;
        H && H.isConnected && H !== document.body && H.focus();
      }
    }
  }, [n, s]);
  const E = T(
    (w) => {
      if (w.preventDefault(), h.current) {
        h.current = !1;
        return;
      }
      a();
    },
    [a]
  ), M = T(
    (w) => {
      if (kt(w.target)) {
        h.current = !0;
        return;
      }
      w.target === d.current && a();
    },
    [a]
  ), y = T((w) => {
    kt(w.target) && (h.current = !1);
  }, []);
  return /* @__PURE__ */ t(
    "dialog",
    {
      ref: d,
      "aria-labelledby": _,
      onCancel: E,
      onClick: M,
      onChange: y,
      className: `${Ae.dialog} ${c ?? ""}`,
      children: /* @__PURE__ */ m("div", { className: Ae.container, children: [
        /* @__PURE__ */ m("header", { className: Ae.header, children: [
          /* @__PURE__ */ t("h2", { id: _, className: Ae.title, children: l }),
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              "aria-label": "Lukk",
              onClick: a,
              className: Ae.close,
              children: /* @__PURE__ */ t(ne, { size: 20, weight: "bold" })
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { ref: u, className: Ae.content, tabIndex: g ? 0 : void 0, children: o }),
        r && /* @__PURE__ */ t("footer", { className: Ae.footer, children: r })
      ] })
    }
  );
}
const jc = "Sheet-module__sheet___4btR1", Jc = "Sheet-module__sheet-enter___Havmm", Qc = "Sheet-module__left___9ursm", es = "Sheet-module__sheet-enter-left___dLT4C", ts = "Sheet-module__backdrop-enter___Yb0N2", as = "Sheet-module__right___FAhmN", ns = "Sheet-module__container___EAOfa", ls = "Sheet-module__header___CcPps", os = "Sheet-module__title___o68zm", rs = "Sheet-module__close___7-U3O", cs = "Sheet-module__content___pPiGe", Ne = {
  sheet: jc,
  sheetEnter: Jc,
  left: Qc,
  sheetEnterLeft: es,
  backdropEnter: ts,
  right: as,
  container: ns,
  header: ls,
  title: os,
  close: rs,
  content: cs
};
function F2({
  open: n,
  onClose: a,
  title: l,
  children: o,
  side: r = "right",
  className: c
}) {
  const s = S(null), d = S(null), i = W();
  U(() => {
    const u = s.current;
    u && (n && !u.open ? (d.current = document.activeElement, u.showModal()) : !n && u.open && (u.close(), d.current?.focus()));
  }, [n]);
  const h = T(
    (u) => {
      u.preventDefault(), a();
    },
    [a]
  ), _ = T(
    (u) => {
      u.target === s.current && a();
    },
    [a]
  );
  return /* @__PURE__ */ t(
    "dialog",
    {
      ref: s,
      "aria-labelledby": i,
      onCancel: h,
      onClick: _,
      className: `${Ne.sheet} ${Ne[r]} ${c ?? ""}`,
      children: /* @__PURE__ */ m("div", { className: Ne.container, children: [
        /* @__PURE__ */ m("header", { className: Ne.header, children: [
          /* @__PURE__ */ t("h2", { id: i, className: Ne.title, children: l }),
          /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              "aria-label": "Lukk",
              onClick: a,
              className: Ne.close,
              children: /* @__PURE__ */ t(ne, { size: 20, weight: "bold" })
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { className: Ne.content, children: o })
      ] })
    }
  );
}
const ss = "Dropdown-module__wrapper___Zyl0q", is = "Dropdown-module__trigger___I0GgP", ds = "Dropdown-module__menu___4sTYp", _s = "Dropdown-module__menu-enter___Q15yI", ms = "Dropdown-module__start___AAl2C", us = "Dropdown-module__end___Hb8HP", ps = "Dropdown-module__groupLabel___aSol7", hs = "Dropdown-module__item___C8H3a", gs = "Dropdown-module__danger___QgHvS", bs = "Dropdown-module__selected___-8iQi", fs = "Dropdown-module__icon___Bji66", vs = "Dropdown-module__separator___9ebsf", $s = "Dropdown-module__portalMenu___SIXIz", ie = {
  wrapper: ss,
  trigger: is,
  menu: ds,
  menuEnter: _s,
  start: ms,
  end: us,
  groupLabel: ps,
  item: hs,
  danger: gs,
  selected: bs,
  icon: fs,
  separator: vs,
  portalMenu: $s
};
function B2({ trigger: n, groups: a, align: l = "start", className: o }) {
  const c = `${W()}-menu`, s = S(null), d = S(null), [i, h] = F(!1), [_, u] = F(-1), [g, N] = F({ top: 0, left: 0 }), E = a.flatMap((p) => p.items), M = T(() => {
    h(!1), u(-1), s.current?.focus();
  }, []), y = T(() => {
    const p = s.current, $ = d.current;
    if (!p || !$)
      return;
    const A = p.getBoundingClientRect(), Z = $.getBoundingClientRect(), f = 4;
    let C = A.bottom + f, k = l === "end" ? A.right - Z.width : A.left;
    C + Z.height > window.innerHeight - 8 && (C = A.top - Z.height - f), k = Math.max(8, Math.min(k, window.innerWidth - Z.width - 8)), N({ top: C, left: k });
  }, [l]);
  At(() => {
    i && y();
  }, [i, y]), U(() => {
    if (!i)
      return;
    const p = (A) => {
      d.current && !d.current.contains(A.target) && !s.current?.contains(A.target) && M();
    }, $ = () => M();
    return document.addEventListener("mousedown", p), window.addEventListener("scroll", $, !0), () => {
      document.removeEventListener("mousedown", p), window.removeEventListener("scroll", $, !0);
    };
  }, [i, M]);
  const w = (p) => {
    (p.key === "ArrowDown" || p.key === "Enter" || p.key === " ") && (p.preventDefault(), h(!0), u(0));
  }, H = (p) => {
    switch (p.key) {
      case "ArrowDown":
        p.preventDefault(), u(($) => ($ + 1) % E.length);
        break;
      case "ArrowUp":
        p.preventDefault(), u(($) => ($ - 1 + E.length) % E.length);
        break;
      case "Home":
        p.preventDefault(), u(0);
        break;
      case "End":
        p.preventDefault(), u(E.length - 1);
        break;
      case "Enter":
      case " ":
        p.preventDefault(), _ >= 0 && !E[_].disabled && (E[_].onClick(), M());
        break;
      case "Escape":
      case "Tab":
        M();
        break;
    }
  };
  U(() => {
    i && _ >= 0 && d.current && d.current.querySelectorAll("[role='menuitem']")[_]?.focus();
  }, [_, i]);
  let b = 0;
  const v = /* @__PURE__ */ t(
    "div",
    {
      ref: d,
      id: c,
      role: "menu",
      onKeyDown: H,
      className: ie.portalMenu,
      style: { top: g.top, left: g.left },
      children: a.map((p, $) => /* @__PURE__ */ m("div", { role: "group", "aria-label": p.label, children: [
        p.label && /* @__PURE__ */ t("span", { className: ie.groupLabel, children: p.label }),
        p.items.map((A) => {
          const Z = b++;
          return /* @__PURE__ */ m(
            "button",
            {
              role: "menuitem",
              tabIndex: Z === _ ? 0 : -1,
              disabled: A.disabled,
              "aria-disabled": A.disabled,
              onClick: () => {
                A.disabled || (A.onClick(), M());
              },
              className: `${ie.item} ${A.danger ? ie.danger : ""} ${A.selected ? ie.selected : ""}`,
              children: [
                A.icon && /* @__PURE__ */ t("span", { className: ie.icon, "aria-hidden": "true", children: A.icon }),
                A.label
              ]
            },
            A.id
          );
        }),
        $ < a.length - 1 && /* @__PURE__ */ t("hr", { className: ie.separator, role: "separator" })
      ] }, $))
    }
  );
  return /* @__PURE__ */ m("div", { className: `${ie.wrapper} ${o ?? ""}`, children: [
    /* @__PURE__ */ t(
      "button",
      {
        ref: s,
        "aria-haspopup": "true",
        "aria-expanded": i,
        "aria-controls": c,
        onClick: () => i ? M() : h(!0),
        onKeyDown: w,
        className: ie.trigger,
        children: n
      }
    ),
    i && ct(v, document.body)
  ] });
}
const As = "Popover-module__wrapper___sKqNa", Ns = "Popover-module__trigger___ylde3", Es = "Popover-module__content___0R1Sx", ws = "Popover-module__popover-enter___bxUWW", Zs = "Popover-module__start___cU0hQ", Ms = "Popover-module__center___1-bCx", ys = "Popover-module__end___NDfi-", ot = {
  wrapper: As,
  trigger: Ns,
  content: Es,
  popoverEnter: ws,
  start: Zs,
  center: Ms,
  end: ys
};
function D2({ trigger: n, children: a, align: l = "center", label: o, className: r }) {
  const s = `${W()}-content`, d = S(null), [i, h] = F(!1);
  return U(() => {
    if (!i)
      return;
    const _ = (g) => {
      d.current && !d.current.contains(g.target) && h(!1);
    }, u = (g) => {
      g.key === "Escape" && h(!1);
    };
    return document.addEventListener("mousedown", _), document.addEventListener("keydown", u), () => {
      document.removeEventListener("mousedown", _), document.removeEventListener("keydown", u);
    };
  }, [i]), /* @__PURE__ */ m("div", { ref: d, className: `${ot.wrapper} ${r ?? ""}`, children: [
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "aria-expanded": i,
        "aria-controls": s,
        onClick: () => h(!i),
        className: ot.trigger,
        children: n
      }
    ),
    i && /* @__PURE__ */ t(
      "div",
      {
        id: s,
        role: "dialog",
        "aria-label": o ?? "Popover",
        className: `${ot.content} ${ot[l]}`,
        children: a
      }
    )
  ] });
}
const Ls = "Tooltip-module__wrapper___cyd3i", Hs = "Tooltip-module__tooltip___uu3d5", Cs = "Tooltip-module__tooltip-enter___hPgJg", ks = "Tooltip-module__top___lf6O8", Ss = "Tooltip-module__bottom___0dKdq", Is = "Tooltip-module__left___zSsLk", Ts = "Tooltip-module__right___3RLFp", xs = "Tooltip-module__portalTooltip___S8GeT", Fs = "Tooltip-module__rich___vXPyH", Bs = "Tooltip-module__title___bX8-Z", Ds = "Tooltip-module__body___psXOb", Vs = "Tooltip-module__pointerLeft___B-kkB", Rs = "Tooltip-module__pointerTop___ISeKX", Ee = {
  wrapper: Ls,
  tooltip: Hs,
  tooltipEnter: Cs,
  top: ks,
  bottom: Ss,
  left: Is,
  right: Ts,
  portalTooltip: xs,
  rich: Fs,
  title: Bs,
  body: Ds,
  pointerLeft: Vs,
  pointerTop: Rs
};
function Xe({
  content: n,
  title: a,
  children: l,
  position: o = "top",
  align: r = "center",
  className: c,
  disableOnMobile: s = !0
}) {
  const i = `${W()}-tooltip`, [h, _] = F(!1), u = S(null), g = S(null), [N, E] = F({ top: 0, left: 0 }), M = S(void 0), y = () => {
    s && window.matchMedia("(hover: none)").matches || (clearTimeout(M.current), M.current = setTimeout(() => _(!0), 200));
  }, w = () => {
    clearTimeout(M.current), _(!1);
  }, H = T(() => {
    const b = u.current, v = g.current;
    if (!b || !v)
      return;
    const p = b.getBoundingClientRect(), $ = v.getBoundingClientRect(), A = 8;
    let Z = 0, f = 0;
    switch (o) {
      case "top":
        Z = p.top - $.height - A, f = p.left + p.width / 2 - $.width / 2;
        break;
      case "bottom":
        Z = p.bottom + A, f = p.left + p.width / 2 - $.width / 2;
        break;
      case "left":
        Z = r === "start" ? p.top : p.top + p.height / 2 - $.height / 2, f = p.left - $.width - A;
        break;
      case "right":
        Z = r === "start" ? p.top : p.top + p.height / 2 - $.height / 2, f = p.right + A;
        break;
    }
    f = Math.max(8, Math.min(f, window.innerWidth - $.width - 8)), Z = Math.max(8, Math.min(Z, window.innerHeight - $.height - 8)), E({ top: Z, left: f });
  }, [o, r]);
  return At(() => {
    h && H();
  }, [h, H]), U(() => {
    if (!h)
      return;
    const b = () => H();
    return window.addEventListener("scroll", b, !0), window.addEventListener("resize", b), () => {
      window.removeEventListener("scroll", b, !0), window.removeEventListener("resize", b);
    };
  }, [h, H]), /* @__PURE__ */ m(
    "span",
    {
      ref: u,
      className: `${Ee.wrapper} ${c ?? ""}`,
      onMouseEnter: y,
      onMouseLeave: w,
      onFocus: y,
      onBlur: w,
      children: [
        /* @__PURE__ */ t("span", { "aria-describedby": h ? i : void 0, children: l }),
        h && ct(
          /* @__PURE__ */ m(
            "span",
            {
              ref: g,
              id: i,
              role: "tooltip",
              className: [
                Ee.portalTooltip,
                a ? Ee.rich : "",
                // Pointer when the tooltip sits to the right of the trigger —
                // applies to both rich and simple variants so the toolbar rail
                // has a consistent visual language.
                o === "right" ? Ee.pointerLeft : "",
                // Align the arrow to the tooltip TOP (rather than its centre)
                // when the tooltip top is flush with the trigger top — the 40px
                // toolbar-icon case. For align="center" the default centred arrow
                // matches the trigger's midpoint.
                o === "right" && r === "start" ? Ee.pointerTop : ""
              ].filter(Boolean).join(" "),
              style: { top: N.top, left: N.left },
              children: [
                a && /* @__PURE__ */ t("span", { className: Ee.title, children: a }),
                /* @__PURE__ */ t("span", { className: Ee.body, children: n })
              ]
            }
          ),
          document.body
        )
      ]
    }
  );
}
const Ps = "ColorPicker-module__wrapper___Nw47x", zs = "ColorPicker-module__label___oQzUZ", Os = "ColorPicker-module__row___d-52x", Ws = "ColorPicker-module__disabled___qIidS", Gs = "ColorPicker-module__swatch___EYEy7", Us = "ColorPicker-module__hiddenInput___-brmd", Ks = "ColorPicker-module__stretch___dF4gm", Xs = "ColorPicker-module__hexInput___6YRDI", pe = {
  wrapper: Ps,
  label: zs,
  row: Os,
  disabled: Ws,
  swatch: Gs,
  hiddenInput: Us,
  stretch: Ks,
  hexInput: Xs
}, Ys = x(
  ({ label: n, value: a = "#0037F8", onChange: l, disabled: o, className: r, id: c, hideLabel: s = !1, stretch: d = !1 }, i) => {
    const h = W(), _ = c ?? h, u = `${_}-hex`, [g, N] = F(a), E = T(
      (y) => {
        const w = y.target.value;
        N(w), l?.(w);
      },
      [l]
    ), M = T(
      (y) => {
        const w = y.target.value;
        N(w), /^#[0-9A-Fa-f]{6}$/.test(w) && l?.(w);
      },
      [l]
    );
    return /* @__PURE__ */ m("div", { className: `${pe.wrapper} ${o ? pe.disabled : ""} ${r ?? ""}`, children: [
      /* @__PURE__ */ t("label", { htmlFor: u, className: `${pe.label} ${s ? "sr-only" : ""}`, children: n }),
      /* @__PURE__ */ m("div", { className: `${pe.row} ${d ? pe.stretch : ""}`, children: [
        /* @__PURE__ */ t("label", { className: pe.swatch, style: { backgroundColor: g }, children: /* @__PURE__ */ t(
          "input",
          {
            ref: i,
            id: _,
            type: "color",
            value: g,
            onChange: E,
            disabled: o,
            className: pe.hiddenInput,
            "aria-label": n
          }
        ) }),
        /* @__PURE__ */ t(
          "input",
          {
            id: u,
            type: "text",
            value: g,
            onChange: M,
            disabled: o,
            className: pe.hexInput,
            spellCheck: !1,
            maxLength: 7
          }
        )
      ] })
    ] });
  }
);
Ys.displayName = "ColorPicker";
const qs = "Slider-module__wrapper___3qLNN", js = "Slider-module__labelRow___BmVW1", Js = "Slider-module__label___7iY-I", Qs = "Slider-module__control___DjmAn", ei = "Slider-module__input___8YnqD", ti = "Slider-module__value___-M4Hv", Ie = {
  wrapper: qs,
  labelRow: js,
  label: Js,
  control: Qs,
  input: ei,
  value: ti
}, ai = x(
  ({ label: n, showValue: a = !0, formatValue: l, hideLabel: o = !1, className: r, id: c, value: s, ...d }, i) => {
    const h = W(), _ = c ?? h, u = l ? l(Number(s ?? 0)) : String(s ?? 0);
    return /* @__PURE__ */ m("div", { className: `${Ie.wrapper} ${r ?? ""}`, children: [
      /* @__PURE__ */ m("div", { className: Ie.labelRow, children: [
        /* @__PURE__ */ t("label", { htmlFor: _, className: `${Ie.label} ${o ? "sr-only" : ""}`, children: n }),
        a && !o && /* @__PURE__ */ t("output", { htmlFor: _, className: Ie.value, children: u })
      ] }),
      /* @__PURE__ */ t("div", { className: Ie.control, children: /* @__PURE__ */ t(
        "input",
        {
          ref: i,
          id: _,
          type: "range",
          value: s,
          className: Ie.input,
          ...d
        }
      ) })
    ] });
  }
);
ai.displayName = "Slider";
const ni = "AppHeader-module__header___qsyM4", li = "AppHeader-module__left___YCGqY", oi = "AppHeader-module__brand___46CvU", ri = "AppHeader-module__brandSm___dhKpK", ci = "AppHeader-module__brandButton___qqWJm", si = "AppHeader-module__logo___evYfE", ii = "AppHeader-module__title___c51gm", di = "AppHeader-module__titleButton___t5zBM", _i = "AppHeader-module__titleButtonIcon___i8fGZ", mi = "AppHeader-module__titleAction___9lEdd", ui = "AppHeader-module__divider___J1Y77", pi = "AppHeader-module__subtitle___V1-vY", hi = "AppHeader-module__contextTitle___E2WsU", gi = "AppHeader-module__contextSubtitle___XrXbP", bi = "AppHeader-module__backArea___YcIxd", fi = "AppHeader-module__backText___XH2Iw", vi = "AppHeader-module__hasCenter___hnLPO", $i = "AppHeader-module__center___Zfwxd", Ai = "AppHeader-module__right___KZ-gW", Ni = "AppHeader-module__userChip___GbZkx", Ei = "AppHeader-module__userName___IYg2F", wi = "AppHeader-module__userRole___HKQ9g", z = {
  header: ni,
  left: li,
  brand: oi,
  brandSm: ri,
  brandButton: ci,
  logo: si,
  title: ii,
  titleButton: di,
  titleButtonIcon: _i,
  titleAction: mi,
  divider: ui,
  subtitle: pi,
  contextTitle: hi,
  contextSubtitle: gi,
  backArea: bi,
  backText: fi,
  hasCenter: vi,
  center: $i,
  right: Ai,
  userChip: Ni,
  userName: Ei,
  userRole: wi
};
function V2({
  logo: n,
  title: a,
  onTitleClick: l,
  titleSize: o = "md",
  showTitleCaret: r = !0,
  subtitle: c,
  titleAction: s,
  onBack: d,
  backLabel: i,
  center: h,
  actions: _,
  user: u,
  className: g
}) {
  const N = !!d, E = `${z.title} ${o === "sm" ? z.titleSm : ""}`, M = `${z.brand} ${o === "sm" ? z.brandSm : ""}`, y = /* @__PURE__ */ m(re, { children: [
    n && /* @__PURE__ */ t("span", { className: z.logo, children: n }),
    /* @__PURE__ */ t("span", { className: E, children: a })
  ] });
  return /* @__PURE__ */ m("header", { className: `${z.header} ${h ? z.hasCenter : ""} ${g ?? ""}`, children: [
    /* @__PURE__ */ t("div", { className: z.left, children: N ? /* @__PURE__ */ m(re, { children: [
      /* @__PURE__ */ m(
        "button",
        {
          type: "button",
          className: z.backArea,
          onClick: d,
          "aria-label": i ?? "Gå tilbake",
          children: [
            /* @__PURE__ */ t(st, { size: 18, "aria-hidden": "true" }),
            i && /* @__PURE__ */ t("span", { className: z.backText, children: i })
          ]
        }
      ),
      /* @__PURE__ */ t("span", { className: z.contextTitle, children: a }),
      c && /* @__PURE__ */ t("span", { className: z.contextSubtitle, children: c })
    ] }) : /* @__PURE__ */ m(re, { children: [
      l ? /* @__PURE__ */ m(
        "button",
        {
          type: "button",
          className: `${z.title} ${z.titleButton}`,
          onClick: l,
          children: [
            /* @__PURE__ */ t("span", { children: a }),
            r && /* @__PURE__ */ t(
              xt,
              {
                size: 16,
                weight: "bold",
                "aria-hidden": "true",
                className: z.titleButtonIcon
              }
            )
          ]
        }
      ) : /* @__PURE__ */ t("span", { className: M, children: y }),
      s && /* @__PURE__ */ t("span", { className: z.titleAction, children: s }),
      c && /* @__PURE__ */ m(re, { children: [
        /* @__PURE__ */ t("span", { className: z.divider }),
        /* @__PURE__ */ t("span", { className: z.subtitle, children: c })
      ] })
    ] }) }),
    h && /* @__PURE__ */ t("div", { className: z.center, children: h }),
    /* @__PURE__ */ m("div", { className: z.right, children: [
      _,
      u && /* @__PURE__ */ m(re, { children: [
        _ && /* @__PURE__ */ t("span", { className: z.divider }),
        /* @__PURE__ */ m("div", { className: z.userChip, children: [
          /* @__PURE__ */ t(
            Wo,
            {
              alt: u.name,
              initials: u.initials,
              src: u.avatarUrl,
              size: "sm"
            }
          ),
          /* @__PURE__ */ m("div", { children: [
            /* @__PURE__ */ t("div", { className: z.userName, children: u.name }),
            u.role && /* @__PURE__ */ t("div", { className: z.userRole, children: u.role })
          ] })
        ] })
      ] })
    ] })
  ] });
}
const Zi = "PageHeader-module__header___W4r3L", Mi = "PageHeader-module__left___Kcr-c", yi = "PageHeader-module__backBtn___LZMYk", Li = "PageHeader-module__textCol___o3iND", Hi = "PageHeader-module__title___GGnoW", Ci = "PageHeader-module__description___MRGDc", ki = "PageHeader-module__actions___KFuAm", Si = "PageHeader-module__compact___peIII", he = {
  header: Zi,
  left: Mi,
  backBtn: yi,
  textCol: Li,
  title: Hi,
  description: Ci,
  actions: ki,
  compact: Si
};
function R2({
  title: n,
  description: a,
  onBack: l,
  backLabel: o = "Tilbake",
  actions: r,
  compact: c = !1,
  className: s
}) {
  return /* @__PURE__ */ m("header", { className: `${he.header} ${c ? he.compact : ""} ${s ?? ""}`, children: [
    /* @__PURE__ */ m("div", { className: he.left, children: [
      l && /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: he.backBtn,
          onClick: l,
          "aria-label": o,
          children: /* @__PURE__ */ t(st, { size: 20, "aria-hidden": "true" })
        }
      ),
      /* @__PURE__ */ m("div", { className: he.textCol, children: [
        /* @__PURE__ */ t("h1", { className: he.title, children: n }),
        a && !c && /* @__PURE__ */ t("p", { className: he.description, children: a })
      ] })
    ] }),
    r && /* @__PURE__ */ t("div", { className: he.actions, children: r })
  ] });
}
const Ii = "SideNav-module__nav___H-s5B", Ti = "SideNav-module__navBorderless___l3cwU", xi = "SideNav-module__navBody___yX8s-", Fi = "SideNav-module__group___FY5gj", Bi = "SideNav-module__groupLabel___JTo39", Di = "SideNav-module__item___8T6AH", Vi = "SideNav-module__itemActive___W2dsZ", Ri = "SideNav-module__icon___U-O98", Pi = "SideNav-module__navCollapsed___LwvV2", zi = "SideNav-module__itemCollapsed___N07sG", Oi = "SideNav-module__toggle___Og-yk", Wi = "SideNav-module__toggleIcon___Bk-nr", Gi = "SideNav-module__toggleLabel___JIpst", Ui = "SideNav-module__toggleCollapsed___M4ZaL", Ki = "SideNav-module__resizeHandle___VcqIT", Xi = "SideNav-module__resizeHandleActive___9-xpF", q = {
  nav: Ii,
  navBorderless: Ti,
  navBody: xi,
  group: Fi,
  groupLabel: Bi,
  item: Di,
  itemActive: Vi,
  icon: Ri,
  navCollapsed: Pi,
  itemCollapsed: zi,
  toggle: Oi,
  toggleIcon: Wi,
  toggleLabel: Gi,
  toggleCollapsed: Ui,
  resizeHandle: Ki,
  resizeHandleActive: Xi
}, yt = Ye({});
function P2({ id: n, icon: a, children: l, description: o }) {
  const { activeId: r, collapsed: c, onSelect: s } = qe(yt), d = r === n, i = /* @__PURE__ */ m(
    "button",
    {
      type: "button",
      className: `${q.item} ${d ? q.itemActive : ""} ${c ? q.itemCollapsed : ""}`,
      onClick: () => s?.(n),
      "aria-current": d ? "page" : void 0,
      "aria-label": c && typeof l == "string" ? l : void 0,
      children: [
        a && /* @__PURE__ */ t("span", { className: q.icon, children: a }),
        !c && l
      ]
    }
  );
  return c && typeof l == "string" ? /* @__PURE__ */ t(
    Xe,
    {
      position: "right",
      align: "start",
      title: o ? l : void 0,
      content: o ?? l,
      children: i
    }
  ) : i;
}
function z2({ label: n, children: a }) {
  const { collapsed: l } = qe(yt);
  return /* @__PURE__ */ m("div", { className: q.group, children: [
    n && !l && /* @__PURE__ */ t("div", { className: q.groupLabel, children: n }),
    a
  ] });
}
function O2({
  activeId: n,
  onSelect: a,
  collapsed: l = !1,
  onCollapseChange: o,
  collapseLabel: r = "Skjul meny",
  expandLabel: c = "Vis meny",
  bordered: s = !0,
  resizable: d,
  defaultWidth: i = 280,
  minWidth: h = 160,
  maxWidth: _ = 500,
  children: u,
  className: g
}) {
  const N = Nt(
    () => ({ activeId: n, collapsed: l, onSelect: a }),
    [n, l, a]
  ), [E, M] = F(i), [y, w] = F(!1), H = S(null), b = S(null);
  U(() => () => {
    b.current?.();
  }, []);
  function v(Z) {
    Z.preventDefault(), H.current = { startX: Z.clientX, startWidth: E }, w(!0);
    function f(k) {
      if (!H.current)
        return;
      const G = k.clientX - H.current.startX;
      M(Math.max(h, Math.min(_, H.current.startWidth + G)));
    }
    function C() {
      H.current = null, w(!1), document.removeEventListener("mousemove", f), document.removeEventListener("mouseup", C), b.current = null;
    }
    b.current = () => {
      document.removeEventListener("mousemove", f), document.removeEventListener("mouseup", C);
    }, document.addEventListener("mousemove", f), document.addEventListener("mouseup", C);
  }
  const p = () => o?.(!l), $ = l ? c : r, A = o ? /* @__PURE__ */ m(
    "button",
    {
      type: "button",
      className: `${q.toggle} ${l ? q.toggleCollapsed : ""}`,
      onClick: p,
      "aria-label": $,
      "aria-expanded": l ? "false" : "true",
      children: [
        /* @__PURE__ */ t("span", { className: q.toggleIcon, children: l ? /* @__PURE__ */ t(wt, { size: 16, "aria-hidden": "true" }) : /* @__PURE__ */ t(Et, { size: 16, "aria-hidden": "true" }) }),
        !l && /* @__PURE__ */ t("span", { className: q.toggleLabel, children: $ })
      ]
    }
  ) : null;
  return /* @__PURE__ */ t(yt.Provider, { value: N, children: /* @__PURE__ */ m(
    "nav",
    {
      className: [
        q.nav,
        l ? q.navCollapsed : "",
        s ? "" : q.navBorderless,
        g ?? ""
      ].filter(Boolean).join(" "),
      style: d && !l ? { width: `${E}px` } : void 0,
      "aria-label": "Sidemeny",
      children: [
        /* @__PURE__ */ t("div", { className: q.navBody, children: u }),
        A && (l ? /* @__PURE__ */ t(Xe, { position: "right", align: "start", content: $, children: A }) : A),
        d && !l && /* @__PURE__ */ t(
          "div",
          {
            className: `${q.resizeHandle}${y ? ` ${q.resizeHandleActive}` : ""}`,
            onMouseDown: v,
            "aria-hidden": "true"
          }
        )
      ]
    }
  ) });
}
const Yi = "Tree-module__tree___RN8OP", qi = "Tree-module__header___a-JEw", ji = "Tree-module__headerLabel___LTi4m", Ji = "Tree-module__items___vdTH9", Qi = "Tree-module__itemWrapper___GWa6q", ed = "Tree-module__row___RYD9D", td = "Tree-module__rowToggle___cACKV", ad = "Tree-module__item___TYtRZ", nd = "Tree-module__expandBtn___D6ILR", ld = "Tree-module__rowActive___Wp5fE", od = "Tree-module__caret___Rk9Bk", rd = "Tree-module__caretExpanded___tCnOV", cd = "Tree-module__itemParent___fokw1", sd = "Tree-module__itemChild___gQ-ES", id = "Tree-module__itemLeaf___4F0F5", dd = "Tree-module__children___hbjjS", _d = "Tree-module__itemActive___EXblp", md = "Tree-module__code___voT0p", ud = "Tree-module__iconSlot___dtC1c", pd = "Tree-module__label___JSz4p", hd = "Tree-module__meta___o-Ru9", gd = "Tree-module__badge___LRkrN", bd = "Tree-module__badgeActive___-JMEd", fd = "Tree-module__childrenWrap___XXl1c", vd = "Tree-module__childrenWrapExpanded___x1Vms", $d = "Tree-module__itemWrapperDragOver___Cetct", D = {
  tree: Yi,
  header: qi,
  headerLabel: ji,
  items: Ji,
  itemWrapper: Qi,
  row: ed,
  rowToggle: td,
  item: ad,
  expandBtn: nd,
  rowActive: ld,
  caret: od,
  caretExpanded: rd,
  itemParent: cd,
  itemChild: sd,
  itemLeaf: id,
  children: dd,
  itemActive: _d,
  code: md,
  iconSlot: ud,
  label: pd,
  meta: hd,
  badge: gd,
  badgeActive: bd,
  childrenWrap: fd,
  childrenWrapExpanded: vd,
  itemWrapperDragOver: $d
}, ca = Ye({});
function W2({
  id: n,
  label: a,
  icon: l,
  code: o,
  meta: r,
  count: c,
  children: s,
  defaultExpanded: d = !1,
  forceExpanded: i,
  dragOver: h,
  dragProps: _
}) {
  const { activeId: u, onSelect: g, expandOnRowClick: N } = qe(ca), [E, M] = F(d), y = i !== void 0 ? i : E, w = !!s, H = u === n, b = w, v = b && N;
  return /* @__PURE__ */ m(
    "div",
    {
      className: `${D.itemWrapper}${h ? ` ${D.itemWrapperDragOver}` : ""}`,
      role: "treeitem",
      "aria-expanded": w ? y : void 0,
      ..._,
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: `${D.row} ${v ? D.rowToggle : ""} ${v && H ? D.rowActive : ""}`,
            children: [
              w ? /* @__PURE__ */ t(
                "button",
                {
                  type: "button",
                  className: D.expandBtn,
                  onClick: () => M((p) => !p),
                  "aria-label": y ? "Lukk" : "Utvid",
                  children: /* @__PURE__ */ t(
                    wt,
                    {
                      size: 16,
                      weight: "light",
                      className: `${D.caret} ${y ? D.caretExpanded : ""}`
                    }
                  )
                }
              ) : null,
              /* @__PURE__ */ m(
                "button",
                {
                  type: "button",
                  className: `${D.item} ${H ? D.itemActive : ""} ${b ? D.itemParent : D.itemChild} ${w ? "" : D.itemLeaf}`,
                  onClick: () => {
                    v && M((p) => !p), g?.(n);
                  },
                  "aria-expanded": v ? E : void 0,
                  "aria-current": H ? "true" : void 0,
                  children: [
                    o && /* @__PURE__ */ t("span", { className: D.code, children: o }),
                    l && /* @__PURE__ */ t("span", { className: D.iconSlot, "aria-hidden": "true", children: l }),
                    /* @__PURE__ */ t("span", { className: D.label, children: a }),
                    r && /* @__PURE__ */ t("span", { className: D.meta, children: r }),
                    c != null && /* @__PURE__ */ t("span", { className: `${D.badge} ${H ? D.badgeActive : ""}`, children: c })
                  ]
                }
              )
            ]
          }
        ),
        w && /* @__PURE__ */ t(
          "div",
          {
            className: `${D.childrenWrap} ${y ? D.childrenWrapExpanded : ""}`,
            children: /* @__PURE__ */ t("div", { className: D.children, role: "group", children: s })
          }
        )
      ]
    }
  );
}
function G2({
  activeId: n,
  onSelect: a,
  label: l,
  headerAction: o,
  children: r,
  className: c,
  expandOnRowClick: s = !1
}) {
  return /* @__PURE__ */ t(ca.Provider, { value: { activeId: n, onSelect: a, expandOnRowClick: s }, children: /* @__PURE__ */ m("div", { className: `${D.tree} ${c ?? ""}`, children: [
    (l || o) && /* @__PURE__ */ m("div", { className: D.header, children: [
      l && /* @__PURE__ */ t("span", { className: D.headerLabel, children: l }),
      o
    ] }),
    /* @__PURE__ */ t("div", { className: D.items, role: "tree", children: r })
  ] }) });
}
function Ad(n) {
  const a = n.trim();
  return /^[a-z][a-z0-9+.-]*:/i.test(a) || a.startsWith("#") || a.startsWith("/") ? a : `https://${a}`;
}
const Nd = "RichEditor-module__wrapper___HXDgD", Ed = "RichEditor-module__label___jFuNp", wd = "RichEditor-module__editor___qSZ3O", Zd = "RichEditor-module__toolbar___qnVLU", Md = "RichEditor-module__toolbarBtn___Y5Zsm", yd = "RichEditor-module__toolbarBtnActive___XY437", Ld = "RichEditor-module__toolbarDivider___l5qX-", Hd = "RichEditor-module__contenteditable___eJtAI", ge = {
  wrapper: Nd,
  label: Ed,
  editor: wd,
  toolbar: Zd,
  toolbarBtn: Md,
  toolbarBtnActive: yd,
  toolbarDivider: Ld,
  contenteditable: Hd
}, St = [
  { id: "bold", command: "bold", label: "Fet", icon: /* @__PURE__ */ t(Xt, { size: 16 }) },
  { id: "italic", command: "italic", label: "Kursiv", icon: /* @__PURE__ */ t(Yt, { size: 16 }) },
  { id: "underline", command: "underline", label: "Understrek", icon: /* @__PURE__ */ t(qt, { size: 16 }) },
  { id: "div1", divider: !0 },
  { id: "ul", command: "insertUnorderedList", label: "Punktliste", icon: /* @__PURE__ */ t(Ot, { size: 16 }) },
  { id: "ol", command: "insertOrderedList", label: "Nummerert liste", icon: /* @__PURE__ */ t(Wt, { size: 16 }) },
  { id: "div2", divider: !0 },
  { id: "link", command: "createLink", label: "Lenke", icon: /* @__PURE__ */ t(zt, { size: 16 }) }
];
function Cd() {
  const n = document.getSelection();
  if (!n || n.rangeCount === 0)
    return null;
  const a = n.getRangeAt(0).commonAncestorContainer;
  return (a.nodeType === Node.ELEMENT_NODE ? a : a.parentElement)?.closest("a") ?? null;
}
function kd(n) {
  try {
    return document.queryCommandState(n);
  } catch {
    return !1;
  }
}
function U2({
  label: n,
  value: a,
  onChange: l,
  placeholder: o = "Skriv her…",
  hideLabel: r = !1,
  className: c
}) {
  const s = S(null), [d, i] = F(/* @__PURE__ */ new Set()), h = S(null), _ = S(null), [u, g] = F(!1), [N, E] = F(""), M = S(void 0);
  U(() => {
    s.current && s.current.innerHTML !== a && (s.current.innerHTML = a);
  }, [a]);
  const y = T(() => {
    const f = document.getSelection(), C = s.current;
    if (!f || f.rangeCount === 0 || !C)
      return;
    const k = f.getRangeAt(0);
    C.contains(k.commonAncestorContainer) && (_.current = k.cloneRange());
  }, []), w = T(() => {
    const f = s.current, C = document.getSelection(), k = _.current;
    if (!(!f || !C || !k) && f.contains(k.commonAncestorContainer))
      try {
        C.removeAllRanges(), C.addRange(k);
      } catch {
      }
  }, []), H = T(() => {
    y();
    const f = /* @__PURE__ */ new Set();
    for (const C of St)
      "command" in C && kd(C.command) && f.add(C.id);
    i(f);
  }, [y]), b = T(() => {
    s.current && l(s.current.innerHTML), H();
  }, [l, H]), v = T((f) => {
    f.preventDefault();
    const C = f.clipboardData.getData("text/plain");
    if (!C)
      return;
    const G = C.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(/\n{2,}/).map((B) => B.replace(/\n/g, " ").trim()).filter((B) => B.length > 0).join(`

`);
    document.execCommand("insertText", !1, G);
  }, []), p = T((f) => {
    if (!("divider" in f)) {
      if (s.current?.focus(), w(), f.command === "createLink") {
        const C = Cd();
        if (C) {
          const k = document.createRange();
          k.selectNodeContents(C), document.getSelection()?.removeAllRanges(), document.getSelection()?.addRange(k);
        }
        y(), E(C?.getAttribute("href") ?? ""), g(!0);
        return;
      }
      document.execCommand(f.command, !1), l(s.current?.innerHTML ?? ""), H();
    }
  }, [w, y, l, H]), $ = T(() => {
    M.current = null, g(!1);
  }, []), A = T(() => {
    M.current = N.trim(), g(!1);
  }, [N]);
  U(() => {
    if (u)
      return;
    const f = M.current;
    f !== void 0 && (M.current = void 0, w(), f && (document.execCommand("createLink", !1, Ad(f)), l(s.current?.innerHTML ?? "")), H());
  }, [u, w, l, H]);
  const Z = T((f) => {
    if (!["ArrowRight", "ArrowLeft", "Home", "End"].includes(f.key) || !h.current)
      return;
    const k = Array.from(h.current.querySelectorAll("button")), G = k.indexOf(document.activeElement);
    if (G === -1)
      return;
    f.preventDefault();
    let B = G;
    f.key === "ArrowRight" && (B = (G + 1) % k.length), f.key === "ArrowLeft" && (B = (G - 1 + k.length) % k.length), f.key === "Home" && (B = 0), f.key === "End" && (B = k.length - 1), k[B].focus();
  }, []);
  return /* @__PURE__ */ m("div", { className: `${ge.wrapper} ${c ?? ""}`, children: [
    n && /* @__PURE__ */ t("label", { className: `${ge.label} ${r ? "sr-only" : ""}`, children: n }),
    /* @__PURE__ */ m("div", { className: ge.editor, children: [
      /* @__PURE__ */ t("div", { ref: h, className: ge.toolbar, role: "toolbar", "aria-label": "Formateringsverktøy", onKeyDown: Z, children: St.map(
        (f) => "divider" in f ? /* @__PURE__ */ t("span", { className: ge.toolbarDivider, "aria-hidden": "true" }, f.id) : /* @__PURE__ */ t(Xe, { content: f.label, children: /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: `${ge.toolbarBtn} ${d.has(f.id) ? ge.toolbarBtnActive : ""}`,
            "aria-label": f.label,
            "aria-pressed": d.has(f.id),
            onMouseDown: (C) => C.preventDefault(),
            onClick: () => p(f),
            children: f.icon
          }
        ) }, f.id)
      ) }),
      /* @__PURE__ */ t(
        "div",
        {
          ref: s,
          className: ge.contenteditable,
          contentEditable: !0,
          suppressContentEditableWarning: !0,
          role: "textbox",
          "aria-multiline": "true",
          "aria-label": n ?? "Teksteditor",
          "data-placeholder": o,
          onInput: b,
          onPaste: v,
          onKeyUp: H,
          onMouseUp: H,
          onBlur: y
        }
      )
    ] }),
    /* @__PURE__ */ t(
      qc,
      {
        open: u,
        onClose: $,
        title: "Lenke",
        returnFocusRef: s,
        footer: /* @__PURE__ */ m(re, { children: [
          /* @__PURE__ */ t(ft, { variant: "secondary", onClick: $, children: "Avbryt" }),
          /* @__PURE__ */ t(ft, { onClick: A, disabled: !N.trim(), children: "Sett inn lenke" })
        ] }),
        children: /* @__PURE__ */ t(
          Mt,
          {
            label: "URL",
            type: "url",
            value: N,
            onChange: (f) => E(f.target.value),
            onKeyDown: (f) => {
              f.key === "Enter" && (f.preventDefault(), N.trim() && A());
            },
            placeholder: "https://",
            autoFocus: !0
          }
        )
      }
    )
  ] });
}
const Sd = "DropZone-module__wrapper___2W-Ax", Id = "DropZone-module__label___ew6UZ", Td = "DropZone-module__zone___bgIev", xd = "DropZone-module__zoneDragOver___k4MYf", Fd = "DropZone-module__zoneIcon___nFMM6", Bd = "DropZone-module__zoneTitle___xIBUv", Dd = "DropZone-module__zoneHint___57P38", Vd = "DropZone-module__grid___QHZy9", Rd = "DropZone-module__thumb___buZTo", Pd = "DropZone-module__thumbPreview___MI5-S", zd = "DropZone-module__thumbImg___TzMOk", Od = "DropZone-module__thumbMeta___eIF-L", Wd = "DropZone-module__thumbName___firGT", Gd = "DropZone-module__thumbRemove___tuEEK", Q = {
  wrapper: Sd,
  label: Id,
  zone: Td,
  zoneDragOver: xd,
  zoneIcon: Fd,
  zoneTitle: Bd,
  zoneHint: Dd,
  grid: Vd,
  thumb: Rd,
  thumbPreview: Pd,
  thumbImg: zd,
  thumbMeta: Od,
  thumbName: Wd,
  thumbRemove: Gd
};
function K2({
  label: n,
  onFiles: a,
  files: l = [],
  onRemove: o,
  accept: r = "image/*",
  multiple: c = !0,
  title: s = "Slipp filer her, eller klikk for å laste opp",
  hint: d = "PNG, JPG eller SVG. Maks 5 MB per fil.",
  hideLabel: i = !1,
  className: h
}) {
  const _ = S(null), [u, g] = F(!1), N = W(), E = `${N}-file`, M = `${N}-label`, y = `${N}-title`, w = `${N}-hint`, H = n ? `${M} ${y}` : y, b = () => _.current?.click(), v = (Z) => {
    Z.target.files && (a?.(Array.from(Z.target.files)), Z.target.value = "");
  }, p = T((Z) => {
    Z.preventDefault(), g(!0);
  }, []), $ = T(() => {
    g(!1);
  }, []), A = T(
    (Z) => {
      Z.preventDefault(), g(!1), Z.dataTransfer.files.length > 0 && a?.(Array.from(Z.dataTransfer.files));
    },
    [a]
  );
  return /* @__PURE__ */ m("div", { className: `${Q.wrapper} ${h ?? ""}`, children: [
    n && /* @__PURE__ */ t(
      "label",
      {
        id: M,
        htmlFor: E,
        className: `${Q.label} ${i ? "sr-only" : ""}`,
        children: n
      }
    ),
    /* @__PURE__ */ t(
      "input",
      {
        ref: _,
        id: E,
        type: "file",
        accept: r,
        multiple: c,
        style: { display: "none" },
        onChange: v
      }
    ),
    l.length > 0 && /* @__PURE__ */ t("div", { className: Q.grid, children: l.map((Z) => /* @__PURE__ */ m("div", { className: Q.thumb, children: [
      /* @__PURE__ */ t("div", { className: Q.thumbPreview, children: Z.previewUrl ? /* @__PURE__ */ t("img", { src: Z.previewUrl, alt: Z.name, className: Q.thumbImg }) : /* @__PURE__ */ t(Rt, { size: 24 }) }),
      /* @__PURE__ */ m("div", { className: Q.thumbMeta, children: [
        /* @__PURE__ */ t("span", { className: Q.thumbName, children: Z.name }),
        o && /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            className: Q.thumbRemove,
            onClick: () => o(Z.name),
            "aria-label": `Fjern ${Z.name}`,
            children: /* @__PURE__ */ t(ne, { size: 12 })
          }
        )
      ] })
    ] }, Z.name)) }),
    /* @__PURE__ */ m(
      "button",
      {
        type: "button",
        className: `${Q.zone} ${u ? Q.zoneDragOver : ""}`,
        "aria-labelledby": H,
        "aria-describedby": w,
        onClick: b,
        onDragOver: p,
        onDragLeave: $,
        onDrop: A,
        children: [
          /* @__PURE__ */ t(Dt, { size: 28, weight: "thin", className: Q.zoneIcon, "aria-hidden": "true" }),
          /* @__PURE__ */ t("span", { id: y, className: Q.zoneTitle, children: s }),
          /* @__PURE__ */ t("span", { id: w, className: Q.zoneHint, children: d })
        ]
      }
    )
  ] });
}
const Ud = "SortableList-module__list___ewfYB", Kd = "SortableList-module__item___1ez1d", Xd = "SortableList-module__row___A5RbG", Yd = "SortableList-module__itemLocked___ADcam", qd = "SortableList-module__itemPinned___yaOFf", jd = "SortableList-module__dragStatic___Crd3H", Jd = "SortableList-module__iconTooltip___rR9ef", Qd = "SortableList-module__itemDragging___Th-Dt", e2 = "SortableList-module__actions___ECgur", t2 = "SortableList-module__drag___HLHIj", a2 = "SortableList-module__body___zPHBr", n2 = "SortableList-module__titleRow___FInlK", l2 = "SortableList-module__title___bMqkA", o2 = "SortableList-module__indexNumber___zNNwO", r2 = "SortableList-module__content___uRePD", c2 = "SortableList-module__contentSeparator___g5wvi", O = {
  list: Ud,
  item: Kd,
  row: Xd,
  itemLocked: Yd,
  itemPinned: qd,
  dragStatic: jd,
  iconTooltip: Jd,
  itemDragging: Qd,
  actions: e2,
  drag: t2,
  body: a2,
  titleRow: n2,
  title: l2,
  indexNumber: o2,
  content: r2,
  contentSeparator: c2
}, Te = 60, It = 14;
function s2(n) {
  let a = n?.parentElement ?? null;
  for (; a; ) {
    const o = getComputedStyle(a).overflowY;
    if ((o === "auto" || o === "scroll") && a.scrollHeight > a.clientHeight)
      return a;
    a = a.parentElement;
  }
  return null;
}
function X2({ count: n, onReorder: a }) {
  const [l, o] = F({ dragIndex: null, overIndex: null }), r = S([]), c = S(0), s = S(0), d = S(0), i = S(0), h = S(null), _ = S(null), u = S(null), g = S(null), N = S(a);
  N.current = a;
  const E = S(n);
  E.current = n;
  const M = T(() => {
    if (h.current == null || i.current === 0)
      return;
    const v = u.current ? u.current.scrollTop - s.current : 0, p = d.current - c.current + v, $ = Math.round(p / i.current), A = Math.max(0, Math.min(E.current - 1, h.current + $));
    A !== _.current && (_.current = A, o({ dragIndex: h.current, overIndex: A }));
  }, []), y = T(() => {
    g.current != null && (cancelAnimationFrame(g.current), g.current = null);
  }, []), w = T(() => {
    const v = u.current;
    if (!v || h.current == null) {
      g.current = null;
      return;
    }
    const p = v.getBoundingClientRect();
    let $ = 0;
    const A = d.current - p.top, Z = p.bottom - d.current;
    if (A < Te && v.scrollTop > 0) {
      const f = Math.min(1, (Te - A) / Te);
      $ = -Math.max(1, f * It);
    } else if (Z < Te && v.scrollTop < v.scrollHeight - v.clientHeight) {
      const f = Math.min(1, (Te - Z) / Te);
      $ = Math.max(1, f * It);
    }
    $ !== 0 && (v.scrollTop += $, M()), g.current = requestAnimationFrame(w);
  }, [M]), H = T((v) => ({
    onPointerDown: (p) => {
      const $ = p.currentTarget;
      $.setPointerCapture(p.pointerId);
      const A = r.current[v];
      A && (i.current = A.getBoundingClientRect().height + parseFloat(getComputedStyle(A.parentElement).gap || "0"));
      const Z = s2(A);
      u.current = Z, s.current = Z?.scrollTop ?? 0, c.current = p.clientY, d.current = p.clientY, h.current = v, _.current = v, o({ dragIndex: v, overIndex: v }), g.current == null && Z && (g.current = requestAnimationFrame(w));
      function f(k) {
        d.current = k.clientY, M();
      }
      function C() {
        $.removeEventListener("pointermove", f), $.removeEventListener("pointerup", C), $.removeEventListener("pointercancel", C), y();
        const k = h.current, G = _.current;
        h.current = null, _.current = null, u.current = null, o({ dragIndex: null, overIndex: null }), k != null && G != null && k !== G && N.current(k, G);
      }
      $.addEventListener("pointermove", f), $.addEventListener("pointerup", C), $.addEventListener("pointercancel", C);
    },
    role: "button",
    tabIndex: 0,
    "aria-roledescription": "sorterbart element",
    onKeyDown: (p) => {
      p.key === "ArrowUp" && v > 0 ? (p.preventDefault(), N.current(v, v - 1)) : p.key === "ArrowDown" && v < E.current - 1 && (p.preventDefault(), N.current(v, v + 1));
    }
  }), [w, M, y]), b = T((v) => {
    let p = 0;
    const { dragIndex: $, overIndex: A } = l;
    $ != null && A != null && $ !== A && (v === $ ? p = (A - $) * i.current : $ < A && v > $ && v <= A ? p = -i.current : $ > A && v >= A && v < $ && (p = i.current));
    const Z = $ === v;
    return {
      ref: (f) => {
        r.current[v] = f;
      },
      style: {
        transform: p !== 0 ? `translateY(${p}px)` : void 0,
        transition: Z ? "none" : "transform 150ms ease",
        zIndex: Z ? 10 : void 0,
        position: "relative"
      }
    };
  }, [l]);
  return { state: l, getDragHandleProps: H, getItemProps: b };
}
const Y2 = x(
  function({
    index: a,
    icon: l,
    title: o,
    description: r,
    meta: c,
    footer: s,
    actions: d,
    dragHandleProps: i,
    isDragging: h,
    showIndex: _ = !1,
    locked: u = !1,
    lockedLabel: g = "Låst — kan ikke flyttes eller redigeres på dette nivået",
    pinPosition: N,
    pinLabel: E,
    children: M,
    expanded: y,
    defaultExpanded: w = !1,
    onExpandedChange: H
  }, b) {
    const [v, p] = F(w), $ = y !== void 0, A = $ ? y : v, Z = W(), f = !!M, C = N !== void 0, k = C ? `Dra for å flytte «${o}» innen ${N === "top" ? "topp-" : "bunn-"}gruppen` : `Dra for å flytte «${o}»`;
    function G() {
      const K = !A;
      $ || p(K), H?.(K);
    }
    const B = !u && i !== void 0, ce = !u && C && !B, _e = E ?? (N === "top" ? "Festet til toppen — kan ikke flyttes opp eller ned" : "Festet til bunnen — kan ikke flyttes opp eller ned"), Be = [
      O.item,
      h && O.itemDragging,
      A && O.itemExpanded,
      u && O.itemLocked,
      C && O.itemPinned
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ m(
      "li",
      {
        ref: b,
        className: Be,
        "data-locked": u || void 0,
        children: [
          /* @__PURE__ */ m(
            "div",
            {
              className: O.row,
              onClick: (K) => {
                !f || K.target.closest("button, a, input, [role='menuitem'], [role='switch']") || G();
              },
              style: f ? { cursor: "pointer" } : void 0,
              children: [
                u && /* @__PURE__ */ t(Xe, { content: g, position: "top", className: O.iconTooltip, children: /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: `${O.drag} ${O.dragStatic}`,
                    "aria-label": g,
                    "aria-disabled": "true",
                    onClick: (K) => K.preventDefault(),
                    children: /* @__PURE__ */ t(Gt, { size: 16, "aria-hidden": "true" })
                  }
                ) }),
                ce && /* @__PURE__ */ t(Xe, { content: _e, position: "top", className: O.iconTooltip, children: /* @__PURE__ */ t(
                  "button",
                  {
                    type: "button",
                    className: `${O.drag} ${O.dragStatic}`,
                    "aria-label": _e,
                    "aria-disabled": "true",
                    onClick: (K) => K.preventDefault(),
                    children: /* @__PURE__ */ t(
                      Kt,
                      {
                        size: 16,
                        "aria-hidden": "true",
                        style: N === "bottom" ? { transform: "rotate(180deg)" } : void 0
                      }
                    )
                  }
                ) }),
                B && /* @__PURE__ */ t(
                  "button",
                  {
                    ...i,
                    type: "button",
                    className: O.drag,
                    "aria-label": k,
                    children: /* @__PURE__ */ t(Vt, { size: 16, "aria-hidden": "true" })
                  }
                ),
                /* @__PURE__ */ m("div", { className: O.body, children: [
                  /* @__PURE__ */ m("div", { className: O.titleRow, children: [
                    l && /* @__PURE__ */ t("span", { className: O.icon, children: l }),
                    _ && /* @__PURE__ */ t("span", { className: O.indexNumber, "aria-hidden": "true", children: a }),
                    /* @__PURE__ */ t("span", { className: O.title, children: o }),
                    c
                  ] }),
                  r && /* @__PURE__ */ t("p", { className: O.desc, children: r }),
                  s
                ] }),
                d && /* @__PURE__ */ t("div", { className: O.actions, children: d }),
                f && /* @__PURE__ */ t(
                  ea,
                  {
                    icon: A ? /* @__PURE__ */ t(Zt, { size: 16 }) : /* @__PURE__ */ t(Fe, { size: 16 }),
                    label: A ? "Lukk" : "Åpne",
                    size: "sm",
                    variant: "outline",
                    onClick: G,
                    "aria-expanded": A,
                    "aria-controls": Z
                  }
                )
              ]
            }
          ),
          f && A && /* @__PURE__ */ m("div", { id: Z, className: O.content, children: [
            /* @__PURE__ */ t("div", { className: O.contentSeparator, "aria-hidden": "true" }),
            M
          ] })
        ]
      }
    );
  }
);
function q2({ children: n, className: a }) {
  return /* @__PURE__ */ t("ul", { className: `${O.list} ${a ?? ""}`, children: n });
}
export {
  h2 as Accordion,
  g2 as ActionBar,
  b2 as ActionGroup,
  I2 as Alert,
  V2 as AppHeader,
  m2 as AppShell,
  Wo as Avatar,
  f2 as BackButton,
  jr as Banner,
  p2 as Block,
  ft as Button,
  J1 as Card,
  L2 as CardContent,
  H2 as CardFooter,
  y2 as CardHeader,
  bt as Checkbox,
  ko as Chip,
  Ys as ColorPicker,
  nl as Combobox,
  S2 as DataTable,
  v0 as DateInput,
  qc as Dialog,
  K2 as DropZone,
  B2 as Dropdown,
  oa as EmptyState,
  Fo as FilterChipGroup,
  v2 as FilterPanel,
  ea as IconButton,
  V1 as List,
  C2 as ListCard,
  K1 as ListItem,
  T2 as Loader,
  rc as Notice,
  _0 as NumberInput,
  R2 as PageHeader,
  gr as Pagination,
  ln as Panel,
  D2 as Popover,
  ul as RadioGroup,
  U2 as RichEditor,
  Jn as SearchInput,
  Ao as SearchResultCard,
  N2 as SegmentedControl,
  C0 as Select,
  A2 as SelectableCard,
  $2 as SelectableCardGroup,
  F2 as Sheet,
  u2 as ShellPanel,
  O2 as SideNav,
  z2 as SideNavGroup,
  P2 as SideNavItem,
  ai as Slider,
  Y2 as SortableItem,
  q2 as SortableList,
  k2 as StatusDot,
  Fl as Switch,
  E2 as TabBar,
  aa as Table,
  la as TableBody,
  Ke as TableCell,
  na as TableHead,
  vt as TableHeaderCell,
  rt as TableRow,
  f0 as TextArea,
  Mt as TextInput,
  Rc as ToastProvider,
  w2 as Toolbar,
  M2 as ToolbarDivider,
  Z2 as ToolbarGroup,
  H1 as ToolbarItem,
  Xe as Tooltip,
  G2 as Tree,
  W2 as TreeItem,
  Ad as normalizeUrl,
  X2 as useSortable,
  x2 as useToast
};
//# sourceMappingURL=index.mjs.map
